import React, {useEffect, useRef, useState} from 'react'
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import style from './index.module.less'
import {noteServer} from '@/common/notesServer'
import SettingIndex from "@/views/Home/views/Setting/SettingIndex";
import {
  delNote,
  getFavorList,
  getNoteById,
  getNoteByIdNoDoc,
  getProjectRecentsList,
  updateNote,
  updateNoteItemToHasUpdate,
  updateNoteName
} from "@model/note";
import {TreeProps} from "antd/es/tree";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {
  ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1,
  ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG, arrayDoubleClickMenu, DEFAULT_SHORTCUTS_CONFIG,
  DESKTOP_PRO_FROM_IMPORT_BACKUP_FILE,
  EVENT_AUTO_UPDATE_IS_READY,
  EVENT_FAVIRIATE_CHANGE,
  EVENT_FORCE_UPDATE, EVENT_ISFULL_SCREEN,
  EVENT_KEYDOWN,
  EVENT_NEW_PROJECT,
  EVENT_NOTE_CHANGED,
  EVENT_NOTE_DELETE, EVENT_OPEN_LIBRARY_ITEM,
  EVENT_REDICTER_TO_DRAW, EVENT_REFRESH_DRAW_FAVOR, EVENT_REFRESH_FAVOR,
  EVENT_REFRESH_HOME_LEFT_MENU, EVENT_REFRESH_JOURNAL,
  EVENT_REFRESH_LIBRARY_LIST, EVENT_REFRESH_LIBRARY_TAG_LIST,
  EVENT_REFRESH_LOGIN_STATUS,
  EVENT_REFRESH_RECENTS, EVENT_REFRESH_TAG_LSIT,
  EVENT_RENAME_PAGES,
  EVENT_RESET_NO_SELECTED,
  EVENT_RESET_SEARCH,
  EVENT_SELECTED_FOLDER,
  EVENT_SHOW_DESKTOP_PRO_VIP, EVENT_SHOW_DIALOG_DRAWINDEX,
  EVENT_SHOW_MESSAGE_BOX,
  EVENT_SWITCH_HOME_LIST_MENU, EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,
  EVENT_UPDATE_NOTE, FROM_DIALOG, FROM_LIBRARY, getNoteElementBackgroundColor,
  HOME_LEFT_MENU_WIDTH, IMPORT_FILE_MODE_ASKME, IMPORT_FILE_MODE_IMPORTMODE, KEY_APP_VERSION,
  KEY_CUSTOMIZE_HOME_20241209,
  KEY_CUSTOMIZE_HOME_REMIND_ME_LATER,
  KEY_DEFAULT_PROJECT_ID,
  KEY_FILE_DIR, KEY_FILE_IMPORT_MODE, KEY_GLOBAL_SHORTCUTS_CONFIG, KEY_GLOBAL_SYNC_AUTO_REFRESH_WHEN_OPEN_APP,
  KEY_HOME_LEFT_MENU_CUSTOMIZE,
  KEY_HOME_SELECT_ITEM,
  KEY_IS_ENABLE_SYNC,
  KEY_LAUNCH_TIMES,
  KEY_MACHINEID,
  KEY_NEW_PROJECT_ID, KEY_PROJECT_THUMB_INDEX,
  KEY_SELECT_RIGHT_SLIDER_MENU, KEY_TRANSCRIPT_DIALOG_HAS_BANNER, LEFT_MENU_WIDTH,
  MAX_CARD_COUNT, MENU_SEPARATOR,
  POST_MESSAGE_REFRESH_FOLDER_LIST, POST_MESSAGE_RENAME_SUB_NOTENAME,
  SYS_CONFIG_KEY_APPFIRST,
  SYS_CONFIG_KEY_STORE_TIPS,
  TITLE_BAR_HEIGHT,
  ZIP_DATA_DB_NAME
} from "@/Const";
import {Dropdown, List, message, Popover, Tooltip,ConfigProvider,Tree, Input} from "antd";
import {useTranslation} from "react-i18next";
import {allFolder, deleteFolder} from "@model/folder";
import {
  createDeeplink,
  createEmptyProject, createFileElementHtml, createPdfAnnoTextElement, decodeDeeplink,
  extFromMineType, formatDate,
  generateRandomPageKey,
  generateUUID2,
  getCtrlOrAlt, getCtrlOrAltCmd, getDrawLeftWidth, getFileImportMode,
  getFileNameWithoutExt,
  getImagePathWithTheme, getImagePathWithThemeSvg, getIntValue,
  getIntValueFromLocalStrage,
  getItem, getLocalFilePath, getNoteFirstHtmlForLeftCard,
  getPdfImageThumb, getSafeInt,
  getVideoImageThumb, getYoutubeThumbUrl,
  hasBeyondFreeLimit, hasDesktopBaseLicense,
  hasLicense, isArray,
  isAudio, isAudioAnnoElement, isBaiduVideoUrl, isBilibiliUrl, isCardAnnoElement,
  isCardEmpty, isCardEmptyCard, isDarkMode, isDeepLink, isDefaultBackgroundColor, isFileElement, isFileVideoElement,
  isFreeCreateCardMode,
  isImage, isInDraw, isInPageLibrary, isNoteElement,
  isPdf, isPdfAnnoElement, isShortcuts,
  isStringNullOrEmpty, isSupportVideoAnnoUrl,
  isSvg, isUrlInDraw,
  isVideo, isVideoAnnoElement, isYoutubeUrl,
  isZipFile,
  logger,
  MenuItem, sleep,
  templatePathPerfix
} from "@/utils";
import DialogNewFolder from "@/views/Home/DialogNewFolder";
import "./HomeIndex.css"
import {
  getImageElementIcon,
  IconAddFolder, IconAddLink,
  IconAddToFavor,
  IconContextMenuCard,
  IconContextMenuPdf,
  IconContextMenuProject, IconCopyLink,
  IconCreateProject,
  IconDelete, IconEdit,
  IconFavorClose,
  IconFile,
  IconHelperCenter,
  IconHelperChangelog,
  IconHelperDiscordCommunity,
  IconHelperRoadmap,
  IconHelperShortcuts,
  IconImport,
  IconImportCard,
  IconImportFile,
  IconImportProject,
  IconNewImage,
  IconNewProject,
  IconNewVideo,
  IconNote,
  IconPdf,
  IconProject, IconRefreshFromCloud,
  IconRemoveFavor,
  IconRename, IconSaveToCloud,
  IconVersionHistory,
  IconWeblink
} from "@/Icon";
import DialogTemplate from "@/views/Home/DialogTemplate";
import {ipcInvoke, ipcOn, ipcSend} from "@/common/ipc";
import DialogMessageBox from "@/common/DialogMessageBox";
import "../../font.css"
import {ENoteAction} from "@/views/Note/NoteItem/NoteItemIndex";
import DialogMovetoFolder from "@/views/Home/DialogMovetoFolder";
import {APP_WEB, APP_WEB_SITE, DEBUG, isOfflineWeb, isWeb, isWebApp} from "@/electron_interactive";
import TitleBar from "@/TitleBar";
import DialogUpdateAvaliable from "@/views/DialogUpdateAvaliable";
import DialogFreeUserUpgrade from "@/views/DialogFreeUserUpgrade";
import FirstInitPage from "@/views/Home/FirstInitPage";
import {
  getCardById,
  getCardCount,
  getCardFavorList,
  getLibraryRecentsList,
  isCardExistInDb,
  updateCard
} from "@model/card";
import global from "@/global";
import withGuard from "@/withGuard";
import {staticS3Size} from "@/api/AwsUpload";
import {
  addImageToLibaray,
  beyondFreePdfLimit,
  beyondFreeVideoLimit, deepLinkToLinkInfo,
  getCardPath,
  getCardTitle,
  getDrawPath, getImageNameFromdeepLinkType, getLibraryTypeImage, getScheme,
  isGlobalRightSlider,
  isMac, isSupportLink, pauseAllVideo, updateFavorToFolder
} from "@/Utility";
import {atom, useAtom} from "jotai";
import JSZip from "jszip";
import {blobToArrayBuffer} from "../../../@excalidraw/packages/excalidraw/data/blob";
import {useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {Import, ImportContext} from "@tiptap-pro/extension-import";
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {imgServer} from "@/components/EditorV2/imgServer";
import {createHashHistory} from "history";
import {isZh} from "@/language";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {disconnectObservable, exportDb, importDb, reconnectObservable} from "@model/init";
import {atomHasDefaultHomePage, atomSliderWidth} from "@/App";
import {atomIsPresentMode, PROJECT_ID} from "@/views/Draw/DrawIndex";

import { Node, Slice, Fragment } from "prosemirror-model";
import {closeEditor} from "@/state";
import {updateCanvasToLibrary} from "@/UpgradeUtils";
import {dbGetHighlight, updateHighlight} from "@model/highlight";
import {videoCache} from "../../../@excalidraw/packages/excalidraw/components/App";
import {isEmbeddableElement, isImageElement} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {getEmbedLink} from "../../../@excalidraw/packages/excalidraw/element/embeddable";
import {toValidURL} from "../../../@excalidraw/packages/excalidraw/data/url";
import {getTagFavorList, updateTag} from "@model/tag";
import {getBoardFavorList, updateBoard} from "@model/board";
import 'react-resizable/css/styles.css';
import {handleImportMarkdown, processZipImport} from "@/components/EditorV2/MarkdownHandle";
import {getBaiduVideoNameByUrl, getCardTitle0} from "@/Utility0";
import {deleteFavorFolder, getFavorFolderList, updateFavorFolder} from "@model/FavorFolder";
import DialogHelper from "@/views/DialogHelper";
import {apiBilibiliCover} from "@/api/ThirdApi";
import {getCustomFilterFavorList, updateCustomFilter} from "@model/customFilter";
import {loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import {debugLog} from "@/LogUtils";
import {updateSysConfig} from "@model/sysconfig";
import CustomAudio from "../../../@excalidraw/packages/excalidraw/components/Audio/CustomAudio";

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import {deleteLinkById, getLinkFavorList} from "@model/link";
import CodeInlie from '@tiptap/extension-code'
import {getTiptapExtension} from "@/components/EditorV2/TiptapTiptapExtension";
import {downloadImageAsBlob, serializeProseMirrorToMarkdown} from "@/components/EditorV2/markdownSerializer";
const {DirectoryTree} = Tree;

//上一个选中的文件夹ID
let mLastSelectId:string = '';
let mArrayFavs:any = [];
let mFolderIsExpand = false;
let mCurrentFavorNote:any;
let mSelectMenuItem = 'home';
let mLastClickedTime = 0;
let mIsFirstFavor = true;
export const atomHomePaddingLeft = atom<any>(HOME_LEFT_MENU_WIDTH);
export const atomSelectSliderRightMenu = atom<any>('library');
export const atomHomeLeftMenu = atom<any>(null);
export const atomCardItemPointerEvent = atom<any>('all');
export const atomIsFullscreen = atom<any>(false);
export const atomIsDragLine = atom<any>(false);
export const atomCommonSliderContainerWidth = atom<any>(0);//画布页面的通用宽度---目前主要用来控制webview相关
export const atomDrawLeftMenuWidth = atom<any>(getDrawLeftWidth());
export const atomTranscriptDialogHasBanner = atom<any>(localStorage.getItem(KEY_TRANSCRIPT_DIALOG_HAS_BANNER) != 'false')

let mHandleTime = 0;
let mIsDefaultDragOk:any = false;
let mRootDiv:any = null;
let mSelectFolder:any = null;
let mIsClickedHandle = false;

const Home = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const dialogNewFolderRef = useRef(null);
  const dialogTemplateRef = useRef(null);
  const dialogMessageBoxRef = useRef(null);
  const dialogMovetoFolderRef = useRef(null);
  const dialogUpdateAvaliable = useRef(null);
  const dialogFreeUserUpgradeRef = useRef(null);
  const dialogSetRef = useRef(null);
  const localParams = useLocation();
  // const {pathname} = useLocation();
  // const [neteAtom] = useAtom(NoteAtom)
  // const favirate = neteAtom.filter(item => item.isFavirated && !item.isDeleted)
  // favirate.sort((a, b) => b.favirateTime - a.favirateTime)

  const [arrayFavirates, setArrayFavirates] = useState([]);
  const [arrayRecents, setArrayRecents] = useState([]);
  const [isShowSettingDialog,setIsShowSettingDialog] = useState(false);
  const [arrayFolders,setArrayFolders] = useState([]);
  const [isExpand,setIsExpand] = useState(mFolderIsExpand);
  const [isExpandFavor,setIsExpandFavor] = useState(false);
  const [isExpandRecent,setIsExpandRecent] = useState(true);
  const [selectMenuItem,setSelectMenuItem] = useState(localStorage.getItem(KEY_HOME_SELECT_ITEM)??mSelectMenuItem);
  const [isAppFirst,setIsAppFirst]=useState(false);
  const [isMoveLeftPartFolder,setIsMoveLeftPartFolder] = useState(false);
  const [isMoveLeftPartFavor,setIsMoveLeftPartFavor] = useState(false);
  const [isMoveLeftPartRecent,setIsMoveLeftPartRecent] = useState(false);
  const [,updateState] = useState();
  const [hasAppUpdate,setHasAppUpdate] = useState(false);
  const forceUpdate = React.useCallback(()=>updateState({}),[]);
  const [showUpgrade,setShowUpgrade] = useState(false);
  const [s3Size,setS3Size] = useState('0Mb');
  const [isShowUpgradeDialog,setIsShowUpgradeDialog] = useState(false);
  const [isFavorHover,setIsFavorHover] = useState(false);
  const [isRecentHover,setIsRecentHover] = useState(false);
  const [currentVersion,setCurrentVersion] = useState('v1.0.0');
  const [isPopupMenuOpen,setIsPopupMenuOpen] = useState(false);
  const [loginAccount,setLoginAccount] = useState(t("Login"))
  const [isFullScreen,setIsFullScreen] = useAtom(atomIsFullscreen);
  const [leftItemHeight,setLeftItemHeight] = useState({favorHeight:'auto',recentHeight:'auto'})
  const [fileImportAccept,setFileImportAccept] = useState('*');
  const [fileMultiply,setFileMultiply] = useState(false);
  const [homeLeftMenu,setHomeLeftMenu] = useAtom(atomHomeLeftMenu);
  const [arrayRecentContextMenu,setArrayRecentContextMenu] = useState<any>([]);
  const [expandKeys,setExpandKeys] = useState([]);
  const [treeSelectedKeys,setTreeSelectedKeys] = useState([]);
  const [treeDraggable,setTreeDraggable] = useState(true);
  const [isShowDialogHelper, setIsShowDialogHelper] = useState(false);
  const [progress, setProgress] = useState(0);
  const [arraySyncMenu,setArraySyncMenu] = useState([]);

  const [hasDefaultHome,setHasDefaultHome] = useAtom(atomHasDefaultHomePage);
  const [homePaddingLeft,setHomePaddingLeft] = useAtom(atomHomePaddingLeft)
  const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
  const [isPresentMode,setIsPresentMode] = useAtom(atomIsPresentMode);
  const fileInputRef = useRef(null);
  const nLastClickTime = useRef(0);
  const mExpandKeys = useRef<any>([]);
  const dialogHelperRef = useRef(null);
  const [hasFavorScrollbarVisible,setHasFavorScrollbarVisible] = useState(false);
  const mFavorEditableId = useRef(null);
  const mIsDragging = useRef(false);
  const mIsMouseInFavor = useRef(false);
  const mIsInExpandClicked = useRef(false);
  const mAppVersion = useRef(null);
  const mIsRefreshFavor = useRef(false);//正在刷新收藏
  const mMapCallback = useRef<any>({});

  const hashHistory = createHashHistory();

  const itemsMore: MenuItem[] = [
    getItem(t("New project"), 'newProject', <IconNewProject/>, undefined, undefined, () => {
      onMenuItemContextMenu("newProject")
    }),
    getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, () => {
      onMenuItemContextMenu("rename")
    }),
    getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, () => {
      onMenuItemContextMenu("delete")
    }),
  ];

  const itemCreateNew:MenuItem[] = [
    getItem(t("Create project"), 'newProject', <IconCreateProject/>, undefined, undefined, async () => {
      newProject();
    }),
    getItem(t("Create card"), 'createCard', <IconImportCard/>, undefined, undefined, async () => {
      //new card
      // Global.g_currentNoteData = {id: generateRandomPageKey()}
      // openEditor(Global.g_currentNoteData.id, false, false);
      //是新建card
      newCard(true);
    }),
  ]

  /**
   * 文件夹的更多菜单
   */
  const itemsFolder = [
    getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, async () => {

    }),
    getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, async () => {

    }),
  ]

  /**
   * 导入项目的
   */
  const itemImportNew:MenuItem[] = [
    getItem(t("Import project"), 'importProject', <IconImportProject/>, undefined, undefined, async () => {
      // if (isWeb()){
      //   window.showTipNotSupportWebOfflineVersion();
      //   return;
      // }
      if (await hasBeyondFreeLimit()){
        postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
        return;
      }

      setFileImportAccept(".pcanvas,.pcanvasx");
      setTimeout(()=>{
        fileInputRef.current?.click();
      },100);
    }),
    getItem(t("Import markdown"), 'importMarkdown', <IconImportCard/>, undefined, undefined, async () => {
      // setFileImportAccept(".md");
      // setTimeout(()=>{
      //   fileInputRef.current?.click();
      // },100);
      importMarkdownMultipe();
    }),
    getItem(t("ImportFileToLibrary"), 'importFile', <IconImportFile/>, undefined, undefined, async () => {
      setFileImportAccept("*");
      setTimeout(()=>{
        fileInputRef.current?.click();
      },100);
    }),
  ]

  /**
   * 同步菜单
   */
  window.refreshSyncMenu = async ()=>{
    const itemSync:MenuItem[] = [
      getItem(<div className={'flex-row-vertical-center'} style={{position:'relative'}}><span>{t("SaveToCloud")}</span><span style={{marginLeft:'auto',color:'var(--text-color-bab8b8)',position:'absolute',right:'0',minWidth:'36px',textAlign:'left'}}>{/*getCtrlOrAlt('Ctrl') + ' + 1'*/}</span></div>, 'saveToCloud', <IconSaveToCloud/>, undefined, undefined, async () => {
        saveToCloud();
      }),
      getItem(<div className={'flex-row-vertical-center'} style={{position:'relative'}}><span>{t("RefreshFromCloud")}</span><span
              style={{marginLeft: 'auto',color:'var(--text-color-bab8b8)',position:'absolute',right:'0',minWidth:'36px',textAlign:'left'}}>{/*getCtrlOrAlt('Ctrl') + ' + 2'*/}</span></div>, 'refreshFromCloud',
          <IconRefreshFromCloud/>, undefined, undefined, async () => {
            refreshFromCloud();
          }),
    ]
    //时间
    const config = await ipcInvoke('read-sync-last-update-time');
    const isEnableSync = localStorage.getItem(KEY_IS_ENABLE_SYNC) == 'true';
    if (isEnableSync && config.lastSyncTime){
      itemSync.push(getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

      }));
      const szLastUpdate = `${t('Last update')}: ${formatDate(config.lastSyncTime,'yyyy-MM-dd hh:mm:ss')}`
      itemSync.push(getItem(<div style={{color:'var(--sync-last-update-time)',height:'100%',margin:'-5px -12px',padding:'5px 12px',background:'var(--dialog-dialog-background-color)'}}>{szLastUpdate}</div>, 'lastUpdateTime',
          null, undefined, undefined, async () => {

          }))
    }

    setArraySyncMenu(itemSync);
  }



  const itemFavor = ()=> {
    return [
      getItem(t("Add folder"), 'addFolder', <IconAddFolder/>, undefined, undefined, async (event) => {
        event.domEvent.stopPropagation();

        const arrayTmp: any = [...arrayFavirates];
        const szId = generateUUID2();
        const item: any = {
          id: szId,
          key: szId + '_' + generateUUID2(),
          name: t("New folder"),
          isFolder: true,
          isEditable: true,
          favirateTime: Date.now(),
          children: [],
        }
        arrayTmp.splice(0, 0, item);
        setArrayFavirates(arrayTmp);
        //保存到库
        updateFavorFolder(item).then(res => {
          onNeedRefreshFavorAAAAAAA();
        });
      }),
      getItem(t("Add link"), 'addLink',
          <IconAddLink/>, undefined, undefined, async (event) => {
            event.domEvent.stopPropagation();
            //如果在draw界面，需要保存一下，因为要取元素的标题
            if (window.saveNotes){
              window.saveNotes();
            }
            window.showDialogAddLink();
          }),
    ]
  }

  const ARRAY_FAVOR_MENU = (item)=>{
    let menu = [
      // {
      //   label: t("Rename"),
      //   key: ENoteAction.rename,
      //   icon: <IconRename/>
      // },
      // {
      //   label: t("Move to folder"),
      //   key: ENoteAction.moveToFolder,
      //   icon: <IconMoveToFolder/>
      // },
      {
        label: t('Cancel favor'),
        key: 'cancelFavor',
        icon: <IconRemoveFavor/>
      },
      // {
      //   label: t('Close'),
      //   key: ENoteAction.close,
      //   icon: <IconFavorClose/>
      // },
      // {
      //   label: t("Generic copy"),
      //   key: ENoteAction.makeACopy,
      //   icon: <IconMakeCopy/>
      // },
      // {
      //   label: t("Delete"),
      //   key: ENoteAction.delete,
      //   icon: <IconDelete/>
      // }
    ]

    if (item.type == 'linkFavor'){
      menu = [
        {
          label: t("Edit link"),
          key: 'editLink',
          icon: <IconEdit/>
        },
        {
          label: t('Cancel favor'),
          key: 'cancelFavor',
          icon: <IconRemoveFavor/>
        },
      ]
    }

    return menu;
  }

  const ARRAY_IMPORT_MENU = [
    getItem(t("Import project"), 'importProject', <IconContextMenuProject/>, undefined, undefined, async () => {
      if (await hasBeyondFreeLimit()){
        postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
        return;
      }
      setFileImportAccept(".pcanvas,.pcanvasx");
      setTimeout(()=>{
        fileInputRef.current?.click();
      },100);
    }),
    getItem(t("Import markdown"), 'importMarkdown', <IconContextMenuCard/>, undefined, undefined, async () => {
      // setFileImportAccept(".md");
      // setTimeout(()=>{
      //   fileInputRef.current?.click();
      // },100);
      importMarkdownMultipe();
    }),
  ]
  /**
   * new content
   */
  const ARRAY_NEW_CONTENT_MENU = [
    getItem(t("New project"), 'newProject', <IconContextMenuProject/>, undefined, undefined, async () => {
      newProject();
    }),
    getItem(<div className={'flex-row-vertical-center'}><span>{t("New card")}</span><span style={{marginLeft:'auto',color:'var(--text-color-bab8b8)'}}>C</span></div>, 'newCard', <IconContextMenuCard/>, undefined, undefined, async () => {
      newCard(true);
    }),
    getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

    }),
    getItem(t("New PDF"), 'newPdf', <IconContextMenuPdf/>, undefined, undefined, async () => {
      window.showDialogLibraryImport('pdf');
    }),
    getItem(t("New video"), 'newVideo', <IconNewVideo/>, undefined, undefined, async () => {
      window.showDialogLibraryImport('video');
    }),
    getItem(t("New image"), 'newImage', <IconNewImage/>, undefined, undefined, async () => {
      window.showDialogLibraryImport('image');
    }),
    getItem(t("New file"), 'newFile', <IconFile/>, undefined, undefined, async () => {
      window.showDialogLibraryImport('file');
    }),
    getItem(t("New weblink"), 'newWeblink', <IconWeblink/>, undefined, undefined, async () => {
      window.showDialogWeblinkImport();
    }),
    getItem(t("Import"), 'import', <IconImport/>, ARRAY_IMPORT_MENU, undefined, async () => {

    }),
  ]

  /**
   * 最近列表...
   */
  const arrayRecentMenu = (item: any) => {
    return [
      getItem(item.isFavirated==1?t("Cancel favor"):t('Add to Favorites'), 'favor', item.isFavirated==1?<IconRemoveFavor/>:<IconAddToFavor/>, null, null, () => {
        mCurrentFavorNote.isFavirated = (item.isFavirated == 1?0:1);
        mCurrentFavorNote.favirateTime = new Date().getTime();
        if (mCurrentFavorNote.type == 'card' || mCurrentFavorNote.type == 'journal'){
          //library
          updateCard(mCurrentFavorNote,false).then(res=>{
            refreshFavor();
            //刷新library列表.
            postMessage(EVENT_REFRESH_LIBRARY_LIST);
            //刷新tag列表
            postMessage(EVENT_REFRESH_TAG_LSIT)
          })
        }else if (mCurrentFavorNote.type == 'tag'){
          updateTag(mCurrentFavorNote).then(res=>{
            refreshFavor();
            //刷新library列表.
            postMessage(EVENT_REFRESH_LIBRARY_LIST);
            //刷新tag列表
            postMessage(EVENT_REFRESH_TAG_LSIT)
          })
        }
        else{
          updateNote(mCurrentFavorNote).then(res=>{
            refreshFavor();
            postMessage(EVENT_REFRESH_FAVOR,{...mCurrentFavorNote})
          })
        }
      }),
      getItem(t("Close"), 'close', <IconFavorClose/>, null, null, () => {
        //从最近移除
        mCurrentFavorNote.viewTime = 1;
        if (mCurrentFavorNote.type){
          if (global.g_currentRecentId == mCurrentFavorNote.id){
            navPage('recent');
          }
          global.g_closedId = mCurrentFavorNote.id;
          //library
          updateCard(mCurrentFavorNote,false).then(res=>{
            refreshRecents(null);
          })
        }else{
          if (global.g_currentRecentId == mCurrentFavorNote.id){
            navPage('recent');
          }
          updateNote(mCurrentFavorNote).then(res=>{
            refreshRecents(null);
          })
        }
      })
    ]
  }

  //右下角helper的更多菜单
  const MENU_HELPER_MORE:MenuItem[] = [
    getItem(t("Discord community"), 'discordCommunity', <IconHelperDiscordCommunity/>, undefined, undefined, async () => {
      ipcSend('open-url',import.meta.env.VITE_HTTP_COMMUNITY);
    }),
    // getItem(t("Tutorial video"), 'tutorialVideo', <IconHelperToutorialVideo/>, undefined, undefined, async () => {
    //
    // }),
    getItem(t("Help center"), 'helpCenter', <IconHelperCenter/>, undefined, undefined, async () => {
      if (isZh()){
        ipcSend('open-url',import.meta.env.VITE_HTTP_HELPER_URL_ZH);
      }else{
        ipcSend('open-url',import.meta.env.VITE_HTTP_HELPER_URL);
      }

    }),
    getItem(t("Changelog"), 'changelog', <IconHelperChangelog/>, undefined, undefined, async () => {
      if (isZh()){
        ipcSend('open-url',import.meta.env.VITE_HTTP_CHANGE_LOG_ZH);
      }else{
        ipcSend('open-url',import.meta.env.VITE_HTTP_CHANGE_LOG);
      }
    }),
    getItem(t("Roadmap"), 'roadmap', <IconHelperRoadmap/>, undefined, undefined, async () => {
      if (isZh()){
        ipcSend('open-url',import.meta.env.VITE_HTTP_ROADMAP_ZH);
      }else{
        ipcSend('open-url',import.meta.env.VITE_HTTP_ROADMAP);
      }
    }),
    getItem(t("Shortcuts"), 'shortcuts', <IconHelperShortcuts/>, undefined, undefined, async () => {
      setIsShowDialogHelper(true);
      setTimeout(() => {
        dialogHelperRef.current?.onShowDialog();
      }, 200);
    }),
  ]

  /**
   * 显示设置对话框
   */
  window.showSettingDialog = (szSelectMenu:any | 'general' |'backup' | 'importFile' | 'sync' | 'webview')=>{
    dialogSetRef?.current?.onDialogShow(szSelectMenu);
  }

  /**
   * 设置左侧选中的条目
   * @param szMenu
   */
  window.setLeftSelect = (szMenu:any)=>{
    setSelectMenuItem(szMenu)
  }

  /**
   * new project
   */
  const newProject = async ()=>{
    if (await hasBeyondFreeLimit()){
      postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''})
      return;
    }
    const szNewProjectId = generateUUID2();
    localStorage.setItem(KEY_NEW_PROJECT_ID,szNewProjectId);
    //创建一个空白项目保存
    const newProject = createEmptyProject(szNewProjectId,'');
    await updateNote(newProject);
    postMessage(EVENT_REFRESH_RECENTS);
    navigate(getDrawPath(),{state:{noteData:newProject}});
  }

  /**
   * 新建card
   * @param isDialog
   */
  const newCard = async (isDialog:any)=>{
    if (!hasLicense() && !hasDesktopBaseLicense()){
      const nCount = await getCardCount();
      if (nCount > MAX_CARD_COUNT && !isFreeCreateCardMode()){
        window.showMessageBox(t("Upgrade required"),t("YouNeedToUpgradeCreateCard"),t("Cancel"),t("Learn more"),null,()=>{
          if (isZh()) {
            ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
          }else {
            ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
          }
        })
        return;
      }
    }
    if (isDialog){
      window.showDialogCard({id:crypto.randomUUID()})
    }else{
      navigate(getCardPath());
    }
  }

  const handleMenuClick = async (e: any,t) => {
    mIsClickedHandle = true;

    let key: any = e.key as ENoteAction;
    if (e.key == 'cancelFavor'){
      key = 'cancelFavor';
    }
    switch (key) {
      case "cancelFavor":
      case ENoteAction.addToFavorite:
        // noteServer.favitateNote(data.id)
        mCurrentFavorNote.isFavirated = 0;
        mCurrentFavorNote.sort = 0;
        mCurrentFavorNote.favirateTime = new Date().getTime();
        if (mCurrentFavorNote.type == 'card' || mCurrentFavorNote.type == 'journal'){
          //library
          updateCard(mCurrentFavorNote,false).then(res=>{
            refreshFavor();
            //刷新library列表.
            postMessage(EVENT_REFRESH_LIBRARY_LIST);
            if (mCurrentFavorNote.type == 'journal'){
              postMessage(EVENT_REFRESH_JOURNAL,{id:mCurrentFavorNote.id})
            }
          })
        }else if (mCurrentFavorNote.type == 'tag'){
          updateTag(mCurrentFavorNote).then(res=>{
            refreshFavor();
            postMessage(EVENT_REFRESH_TAG_LSIT);
          })
        }else if (mCurrentFavorNote.type == 'board'){
          updateBoard(mCurrentFavorNote).then(res=>{
            refreshFavor();
          })
        }else if (mCurrentFavorNote.type == 'customFilter'){
          updateCustomFilter(mCurrentFavorNote).then(res=>{
            refreshFavor();
            //刷新customfilter
            if (window.refreshList['refreshCustomFilter']){
              window.refreshList['refreshCustomFilter']();
            }
          })
        }else if (mCurrentFavorNote.type == 'linkFavor'){
          deleteLinkById(mCurrentFavorNote.id).then(res=>{
            refreshFavor();
            const deeplink = decodeDeeplink(mCurrentFavorNote.url);
            window.globalRefreshList('onRemoveItemOnFavorTab_',deeplink.id);
          });
        }
        else{
          updateNote(mCurrentFavorNote).then(res=>{
            refreshFavor();
            postMessage(EVENT_REFRESH_FAVOR,{...mCurrentFavorNote})
            postMessage(EVENT_REFRESH_DRAW_FAVOR);
            //这里要刷新首页的...收藏...
            window.refresh_project_list_in_favor();
          })
        }
        break;
      case ENoteAction.makeACopy:
        // noteServer.copy(data.id)
        var noteCopy = {...mCurrentFavorNote};
        noteCopy.id = generateRandomPageKey();
        noteCopy.name = noteCopy.showName = noteCopy.name+`${(t("Copy"))}`;
        noteCopy.createTime = Date.now();
        noteCopy.updateTime = new Date().getTime();
        noteCopy.favirateTime = Date.now();
        noteCopy.isFavirated = 0;
        if (isStringNullOrEmpty(noteCopy.doc)){
          const dbNote = await getNoteById(mCurrentFavorNote.id);
          noteCopy.doc = dbNote?.doc;
        }
        updateNoteItemToHasUpdate(noteCopy);

        updateNote(noteCopy).then(res=>{
          postMessage(EVENT_NOTE_CHANGED,{});
        })
        break;
      case ENoteAction.rename:
        noteServer.rename(mCurrentFavorNote)
        break;
      case ENoteAction.delete:
        // const deleteRet = await confirmServer.open(t("Confirm delete"), t("Delete note can view trash"), t("Delete"))
        // if (deleteRet) {
        //   // noteServer.deleteNote(data.id)
        //   delNote(data);
        // }
        postMessage(EVENT_SHOW_MESSAGE_BOX,mCurrentFavorNote);
          // refreshFavor();
        break;
      case ENoteAction.moveToFolder:
        dialogMovetoFolderRef?.current?.onShowDialogEvent(mCurrentFavorNote);
        break;
      case 'editLink':
        window.showDialogAddLink(mCurrentFavorNote)
        break;
    }
  };

  /*转到收藏的画布*/
  const navFavor = async (item:any) => {
    global.g_isNotRefreshFavor = true;
    if (item.type == 'card'){
      //library类型..
      // const doc = await getCardDoc(item.id);
      // Global.g_currentNoteData = {...item, doc};
      // openEditor(item.id,false,false);
      navigate(getCardPath(),{state:{cardId:item.id}})
    }else if (item.type == 'tag'){
      setSelectMenuItem('tags');
      // navigate('/home/tags',{state:{tag:item,from:'favor'}});
      navigate('/home/tagItemList',{state:{tagItem:item,from:'nav'}})
      return false;
    }else if (item.type == 'board'){
      //转到特定的画布
      navigate(getDrawPath(),{state:{folderId:'',projectId:item.projectId,linkInfo:{pageId:item.id},forceRefresh:true}});
    }else if (item.type == 'journal'){
      navPage('journal',item.id);
      return false;
    }else if (item.type == 'customFilter'){
      setSelectMenuItem('library');
      navigate("/home/library",{state:{customFilter:item}});
    }else if (item.type == 'linkFavor'){
      if (isSupportLink(item.url)){
        ipcInvoke('open-url-withwhen',item.url)
      }else if (isDeepLink(item.url)){
        const deeplink = decodeDeeplink(item.url);
        if (deeplink.type == 'project'){
          const linkInfo = await deepLinkToLinkInfo(deeplink);
          postMessage(EVENT_SHOW_DIALOG_DRAWINDEX,{linkInfo:linkInfo});
        }else{
          //打开库中的数据
          if (deeplink.type == 'highlight'){
            postMessage(EVENT_OPEN_LIBRARY_ITEM,{id:deeplink.childId || deeplink.id,deeplink:deeplink,isOpenInPage:true});
          }else{
            postMessage(EVENT_OPEN_LIBRARY_ITEM,{id:deeplink.id,deeplink:deeplink,isOpenInPage:true});
          }

        }
      }else{
        ipcInvoke('open-url-withwhen',item.url)
      }
    }
    else{
      //控制连续快速点击。
      if ((Date.now() - mLastClickedTime) < 200)return false;
      const dbNote = await getNoteById(item.id);
      if (dbNote === null){
        noteServer.openTip("error", "Project not exist!");
        return false;
      }
      navigate(getDrawPath(), {state: {noteData: dbNote}})
      mLastClickedTime = Date.now();
    }
    return true;
  }


  let isFirst = localStorage.getItem(SYS_CONFIG_KEY_APPFIRST) === null;
  if (isFirst){
    localStorage.setItem("lastestCanvasColor",'');
  }

  /**
   * 按键
   * @param event
   */
  const onKeydownListener = (e:any)=>{
    // debugLog('keydown',e);

    let szKey = e.key?.toLowerCase();
    const isRefresh = (
        (e.ctrlKey || e.metaKey) && szKey === 'r' || // Ctrl/Cmd + R
        e.key === 'F5' ||
        (e.ctrlKey && szKey === 'F5')
    )

    if (isRefresh) {
      e.preventDefault()
      e.stopPropagation()
    }

    let szW:any = KEYS.W;
    if (DEBUG){
      //做测试用。。。。。w 被electron 占了，而且是关闭窗口，换这个东西太麻烦.
      szW = KEYS.E;
    }


    if (e.metaKey || e.ctrlKey){
      if (szKey == szW){
        //显示或隐藏所有浮窗？？？？
        if (window.getPinCount() > 0){
          //每次都显示.
          message.destroy();
          if (global.g_isHiddenAllFloatWin){
            message.info(t("ExistFloatMode"));
          }else{
            message.info(t("HasStartFloatMode"));
          }

          if (!global.g_hasFloatWindowHiddenTip){
            global.g_hasFloatWindowHiddenTip = true;
          }

          global.g_isHiddenAllFloatWin = !global.g_isHiddenAllFloatWin;
          window.showOrHiddenAllFloatWin();
        }
      }
    }

    if (!e.target?.editor &&
        e.target?.type != 'text' &&
        e.target?.type != 'textarea' &&
        e.target?.className.indexOf('ql-editor') != 0 &&
        e.target.dataset?.isedit != 'true' &&
        e.target?.className.indexOf('tiptap') != 0) {
      if (e.metaKey || e.ctrlKey){
        console.log('****************************'+e.key);
        let isHandle = false;
        if (e.key == '/'){
          if (homePaddingLeft == 0){
            setHomePaddingLeft(HOME_LEFT_MENU_WIDTH)
          }else{
            setHomePaddingLeft(0)
          }
          isHandle = true;
        }
        // else if (e.key == KEYS["1"]){
        //   //取消网盘的刷新及保存快捷键
        //   // saveToCloud();
        // }else if (e.key == KEYS["2"]){
        //   // refreshFromCloud();
        // }
        else if (isGlobalRightSlider() && e.key == KEYS["1"]){
          if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'library' && rightSliderWidth > 0){
            window.closeRightSlider();
            return;
          }
          localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'library');
          window.openRightSlider(null,'library');
          isHandle = true;
        }else if (isGlobalRightSlider() && e.key == KEYS["2"]){
          if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'journal' && rightSliderWidth > 0){
            window.closeRightSlider();
            return;
          }
          localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'journal');
          window.openRightSlider(null,'journal');
          isHandle = true;
        }else if (isGlobalRightSlider() && e.key == KEYS["3"]){
          if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'highlight' && rightSliderWidth > 0){
            window.closeRightSlider();
            return;
          }
          localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'highlight');
          window.openRightSlider(null,'highlight');
          isHandle = true;
        }else if (isGlobalRightSlider() && e.key == KEYS["4"]){
          if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'info' && rightSliderWidth > 0){
            window.closeRightSlider();
            return;
          }
          localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'info');
          window.openRightSlider(null,'info');
          isHandle = true;
        }else if (isGlobalRightSlider() && e.key == KEYS["5"]){
          if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'project' && rightSliderWidth > 0){
            window.closeRightSlider();
            return;
          }
          localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'project');
          window.openRightSlider(null,'project');
          isHandle = true;
        }else if (isGlobalRightSlider() && e.key == KEYS["6"]){
          if (localStorage.getItem(KEY_SELECT_RIGHT_SLIDER_MENU) == 'webview' && rightSliderWidth > 0){
            window.closeRightSlider();
            return;
          }
          localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU, 'webview');
          window.openRightSlider(null,'webview');
          isHandle = true;
        }
        else if (szKey == KEYS.K){

        }

        if (isHandle){
          e.preventDefault();
          e.stopPropagation();
        }
      }else if(szKey == KEYS.ESCAPE){

      }

      //自定义的快捷键，增加各种判断...
      if (!global.g_showDialogs['settingIndex'] && isShortcuts(e,'globalSearch')){
        setTimeout(()=>{
          if (global.g_showDialogs['dialogLink']){

          }else{
            window.showDialogGlobalSearch();
          }
        },100)
      }
    }

    if(szKey == KEYS.ESCAPE.toLowerCase()){
      // postMessage(EVENT_KEYDOWN,({event:event}));
      if (window.pageDrawIndexEscape){
        window.pageDrawIndexEscape();
      }
      if (!isUrlInDraw()){
        if (!window.hasDialogShow()){
          window.closeRightSlider();
        }
      }
    }
  }

  const onDragOverListener = (event)=>{
    event.preventDefault();
    event.stopPropagation();
  }
  const onDropListener = (event)=>{
    event.preventDefault();
    onDropFile(event);
    return false;
  }

  /**
   * 鼠标左键点击
   * @param event
   */
  const onMouseLeftButtonDown = (event)=>{
    // if (global.g_openDialogs.dialogInfos){//当前打开的有info对话框
    //   return;
    // }
    // window.closeUnpinDialogCard();
    // window.closeUnpinDialogPdf();
    // window.closeUnpinDialogVideos();
  }

  const onContextMenu = (event)=>{
    event.preventDefault();
    return false;
  }

  /**
   * 粘贴*****
   * @param event
   */
  const onPaste = (event)=>{
    if (window.location.href.includes('/library') ||
        window.location.href.includes('/draw') ||
        window.location.href.includes('/defaultProject') ||
        global.g_isDialogLink ||
        (global.g_showDialogs['dialogChooseThumb'] == true) ||
    window.location.href.includes('/card') ||
    window.location.href.includes('/journal') ||
    window.getDialogCardsCount() > 0)return;


    if ((Date.now() - mHandleTime) < 200)return;
    mHandleTime = Date.now();
    onHanldeLastPaste(event);
  }

  /**
   * 处理粘贴....
   * @param event
   */
  const onHanldeLastPaste = async (event)=>{
    let szType;
    let szTipInfo = '';
    if (event.clipboardData.files && event.clipboardData.files.length > 0){
      const files = event.clipboardData.files;
      for (let i=0;i<files.length;i++){
        const file = files[i];
        //保存到库..
        if (file.path){
          if (!isImage(file.path))continue;
          //实际路径的图片
          const szFileName = await ipcInvoke('copy-file', {filePath: file.path});
          szType = 'file';
          szTipInfo = t("FileHasAddLibrary")
          if (isImage(file.path)){
            szType = 'image';
            szTipInfo = t("ImageImportToLibrary")
          }else if (isAudio(file.path)){
            szType = 'audio'
            szTipInfo = t("AudioHasAddLibrary")
          }else if (isVideo(file.path)){
            szType = 'video';
            szTipInfo = t("VideoHasAddLibrary")
          }else if (isPdf(file.path)){
            szType = 'pdf';
            szTipInfo = t("PdfHasAddLibrary")
          }

          let libraryItem = await addImageToLibaray(szType,szFileName);
          //来自link-要显示一个对话框
          if (szType == 'image' || szType == 'video'){
            window.showDialogPasteMediaAddTo(libraryItem,(libraryData:any)=>{
              //回调...

            },szTipInfo);
          }
          postMessage(EVENT_REFRESH_LIBRARY_LIST);
        }else{
          document.body.focus();
          setTimeout(()=>{
            navigator.clipboard.read().then(async (clipboardItems) => {
              for (const clipboardItem of clipboardItems) {
                for (const type of clipboardItem.types) {
                  if (type.startsWith('image/')) {
                    const blob = await clipboardItem.getType(type);
                    const reader = new FileReader();

                    reader.onload = async function(event) {
                      const szBase64 = event.target.result;
                      if (szBase64){
                        const szFileName = 'screenshot_'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.png';
                        // 处理图片
                        var item = {
                          fileName:szFileName,
                          data:szBase64.split(',')[1]
                        }
                        await ipcInvoke('write-base64-files',JSON.stringify([item]));
                        let libraryItem = await addImageToLibaray('image',szFileName);
                        postMessage(EVENT_REFRESH_LIBRARY_LIST);

                        szType = 'image';
                        szTipInfo = t("ImageImportToLibrary")
                        if (szType == 'image' /*|| szType == 'video'*/){
                          window.showDialogPasteMediaAddTo(libraryItem,(libraryData:any)=>{
                            //回调...

                          },szTipInfo);
                        }
                      }
                    };

                    reader.readAsDataURL(blob); // 转换图片为DataURL格式
                  }
                }
              }
            });
          },100)
        }
      }
      //刷新库....
      if (szTipInfo){
        message.info(szTipInfo)
      }
    }
  }

  //每次都执行的....
  useEffect(()=>{
    recvMessage(EVENT_FAVIRIATE_CHANGE,(msg,data)=>{
      refreshFavor();
    })
    recvMessage(EVENT_NOTE_DELETE,(msg,data)=>{
      refreshFavor();
    })

    recvMessage(EVENT_REFRESH_RECENTS,(msg,data)=>{
      refreshRecents(data?.data?.projectId);
    })

    //选中左侧列表
    recvMessage(EVENT_SELECTED_FOLDER,(msg,data)=>{
      //find index
      var nIndex = arrayFolders.findIndex(p=>p.id == data.data.id);
      onNavFolderItem(nIndex);
    });

    recvMessage(EVENT_REDICTER_TO_DRAW,(msg,data)=>{
      // const navigate = useNavigate();
      window.closeAllDialog();
      // navigate(getDrawPath(),{state:{noteData:data.data.project,searchKey:'',cardId:data.data.cardId}})
      // window.navigate(getDrawPath(),{searchKey:'',linkInfo:{id:info.node.key, pageId:info.node.element?.customData?.boardId}})
      navigate(getDrawPath(), {state: {noteData: data.data.project,linkInfo:data.data.linkInfo}})
    })

    recvMessage(EVENT_RESET_NO_SELECTED,(msg,data)=>{
      setSelectMenuItem('')
    })

    document.body.addEventListener('keydown',onKeydownListener);


    if (isWeb()){
      document.addEventListener('contextmenu',onContextMenu);
    }


    return ()=>{
      unSubscribe(EVENT_FAVIRIATE_CHANGE)
      unSubscribe(EVENT_NOTE_DELETE)
      unSubscribe(EVENT_SELECTED_FOLDER)
      unSubscribe(EVENT_REDICTER_TO_DRAW)
      unSubscribe(EVENT_REFRESH_RECENTS)
      unSubscribe(EVENT_RESET_NO_SELECTED)
      document.body.removeEventListener('keydown',onKeydownListener);
      if (isWeb()){
        document.removeEventListener('contextmenu',onContextMenu);
      }
    }
  })

  /**
   * 单次的.
   */
  useEffect(()=>{
    document.title = APP_WEB?t("Untitled"):t("Home");
    window.title = t("Home");

    window.refreshSyncMenu();

    // 添加内存监控
    // setInterval(() => {
    //   const memory = performance.memory;
    //   console.log(`GPU内存使用:      Total: ${memory.totalJSHeapSize / 1048576} MB     Used: ${memory.usedJSHeapSize / 1048576} MB`);
    // }, 5000);

    //读取左侧菜单
    const szLeftMenu = localStorage.getItem(KEY_HOME_LEFT_MENU_CUSTOMIZE);

    let hhh = null;
    if (szLeftMenu){
      hhh = JSON.parse(szLeftMenu);
      if (hhh.properties == undefined){
        hhh.properties = true;
      }
      setHomeLeftMenu(hhh);
    }

    let bHasDefaultHome = hhh?.home;//localStorage.getItem(KEY_HAS_DEFAULT_HOME) == 'true';

    setHasDefaultHome(bHasDefaultHome);
    setSelectMenuItem((bHasDefaultHome)?'home':'recent');
    navPage(bHasDefaultHome?'home':'recent');

    //异步再加载一次配置
    // getSysConfig(KEY_HOME_LEFT_MENU_CUSTOMIZE).then(res=>{
    //     if (res?.value){
    //       setHomeLeftMenu(res.value);
    //       setHasDefaultHome(res.value.home);
    //       setSelectMenuItem((res.value.home)?'home':'recent');
    //     }
    // })

    setIsAppFirst(isFirst);
    setShowUpgrade(!hasLicense() && !hasDesktopBaseLicense());

    let bNeedRemind = false;
    if (localStorage.getItem(KEY_CUSTOMIZE_HOME_REMIND_ME_LATER) == 'true'){
      const nLaunchTimes = getIntValueFromLocalStrage(KEY_LAUNCH_TIMES)
      if (nLaunchTimes % 3 == 0){
        // bNeedRemind = true;//显示一次不要再显示了...
      }
    }

    //简单问题复杂化.--非要直接连续升级2次测这种问题？
    //判断是否需要定制首页
    if (localStorage.getItem(KEY_CUSTOMIZE_HOME_20241209) != 'true' || bNeedRemind){
      if (!isFirst){
        onShowChangeTabTip();
      }
    }

    //监听历史记录回调
    hashHistory.listen(({location, action})=>{
      console.log(location);
      if (action?.toLowerCase() == 'pop'){
        if (location.pathname.includes('/library')){
          //选中库
          setSelectMenuItem('library')
        }else if (location.pathname.includes('/tags') || location.pathname.includes('/tagItemList')){
          setSelectMenuItem('tags')
        }else if (location.pathname.includes('/highlight')){
          setSelectMenuItem('highlight')
        }else if (location.pathname.includes('/journal')){
          setSelectMenuItem('journal')
        }else if(location.pathname.includes('/draw')){
          setSelectMenuItem('');
        }else if (location.pathname.includes('/home/defaultProject')){
          setSelectMenuItem('home');
          resetRecentNoSelect();
        }
        else{
          setSelectMenuItem('recent')
        }
      }
    })

    ipcOn('full-screen',(event,args)=>{
      setIsFullScreen(args.isFullScreen);
      postMessage(EVENT_ISFULL_SCREEN,{isFullScreen:args.isFullScreen});
      if (window.backupPaddingLeft){
        window.backupPaddingLeft();
      }
    })

    ipcOn('notify-main-open-quicknote-set',(event,args)=>{
      dialogSetRef.current?.onDialogShow('quickNote');
    })

    //首次自动全屏的话，加一个检测
    ipcInvoke('is-full-screen').then(res=>{
      if (res == true){
        setIsFullScreen(true);
      }
    })

    recvMessage(POST_MESSAGE_REFRESH_FOLDER_LIST,(msg,data)=>{
      refreshFolder();
    },false);

    recvMessage(EVENT_AUTO_UPDATE_IS_READY,(msg,data)=>{
      setIsShowUpgradeDialog(true);
      dialogUpdateAvaliable.current?.onShowDialog(data.data.version);
    },true);

    recvMessage(EVENT_RENAME_PAGES,async (msg,data)=>{
      getNoteByIdNoDoc(data.data.id).then(async (res)=>{
        res.name = res.showName = res.searchName = data.data.name;
        await updateNoteName(res);
        refreshFavor();
        postMessage(EVENT_NOTE_CHANGED);
        postMessage(EVENT_REFRESH_TAG_LSIT);
        //刷新项目中的projectlink 如果有的话.
        window.globalRefreshList('embedProject_');
        window.globalRefreshList('refreshLibraryList_')
        if (window.onRefreshContentElement){
          window.onRefreshContentElement();
        }
        window.globalRefreshList('refresh_tableview_single_data_',res.id,{type:'project'})
      })
    },true);

    recvMessage(EVENT_REFRESH_LOGIN_STATUS,()=>{
      setShowUpgrade(!hasLicense() && !hasDesktopBaseLicense())
    },false);

    recvMessage(EVENT_SWITCH_HOME_LIST_MENU,(msg,data)=>{
      setSelectMenuItem(data.data.name);
      if (data.data.name == 'recent'){
        onRecentClick();
      }else if (data.data.name == 'library'){
        navigate('/home/library');
      }else if (data.data.name == 'tags'){
        navigate('/home/tags');
      }else if (data.data.name == 'draw'){
        if (data.data.linkInfo){//外部打开的deeplink
          global.g_isRecvDeeplinkMessage = true;
        }
        if (data.data.linkInfo.id == KEY_DEFAULT_PROJECT_ID){
          //带链接信息转到首页...
          getNoteById(data.data.linkInfo.id,true).then(res=>{
            navigate(getDrawPath(), {state: {noteData: res,linkInfo:data.data.linkInfo}})
          })

          setTimeout(()=>{
            setSelectMenuItem('home');
          },50)

          //最近置空
          resetFavorNoSelect();
          resetRecentNoSelect();
        }else{
          getNoteById(data.data.linkInfo.id,true).then(res=>{
            navigate(getDrawPath(), {state: {noteData: res,linkInfo:data.data.linkInfo}})
          })
        }
      }
    })

    //保存笔记............
    recvMessage(EVENT_UPDATE_NOTE,async (msg:any,data:any)=>{
      const card = data.data.data;
      const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
      const nExist = await isCardExistInDb(data.data.data.id);
      if (isCardEmpty(card.doc) && isEmptyTitle && !nExist){
        return;
      }
      card.type = card.type || 'card';
      await updateCard(card,true,true,'fromHomeIndex-EVENT_UPDATE_NOTE');
      refreshFavor();
    });

    refreshFavor();
    refreshRecents();

    if (selectMenuItem == 'library'){
      navigate('/home/library');
    }else if (selectMenuItem == 'tags'){
      navigate('/home/tags');
    }

    //calc
    staticS3Size().then(res=>{
      setS3Size(res);
    });

    //deeplink消息
    ipcInvoke('check-deeplink').then((args:any)=>{
      logger('check-deeplink:'+global.g_isRecvDeeplinkMessage + ' \nargs:'+args)
      if (args && !global.g_isRecvDeeplinkMessage){
        //有deeplink并且没有接收到消息
        // const deeplink = decodeDeeplink(args);
        // if (deeplink.type == 'project'){
        //   deepLinkToLinkInfo(deeplink).then(linkInfo=>{
        //     // postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo});
        //     postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'draw',linkInfo:linkInfo})
        //   });
        // }else if (deeplink.type == 'library'){
        //   postMessage(EVENT_OPEN_LIBRARY_ITEM,{id:deeplink.id,from:FROM_LIBRARY})
        // }
      }
    })

    ipcInvoke('app-version').then((args)=>{
      mAppVersion.current = args;
      setCurrentVersion('v'+args);
    })

    // dialogUpdateAvaliable.current?.onShowDialog('1');
    // setShowUpgrade(true)

    // refreshFolder();

    if (!isFirst){
      if (localStorage.getItem(SYS_CONFIG_KEY_STORE_TIPS) != 'true'){
        onShowStoreTips();
      }
    }

    recvMessage(EVENT_REFRESH_HOME_LEFT_MENU,(msg,data)=>{
      //异步再加载一次配置
      // getSysConfig(KEY_HOME_LEFT_MENU_CUSTOMIZE).then(res=>{
      //   if (res?.value){
      //     setHomeLeftMenu(res.value);
      //     setHasDefaultHome(res.value.home);
      //     setSelectMenuItem((res.value.home)?'home':'recent');
      //     //反向保存到storage
      //     localStorage.setItem(KEY_HOME_LEFT_MENU_CUSTOMIZE,JSON.stringify(res.value));
      //   }
      // })
    })

    const handleOutsideBlockLinkClick = (event) => {
      sessionStorage.setItem('block-id', event.detail.blockId)
      sessionStorage.setItem('block-type', event.detail.blockType)
      sessionStorage.setItem('ifFullScreen', 'false')
      // openEditor(event.detail.noteId)
      getCardById(event.detail.noteId).then(res=>{
        if (event.detail.nagivateEvent?.ctrlKey || event.detail.nagivateEvent?.metaKey){
          //侧栏打开...
          postMessage(EVENT_OPEN_LIBRARY_ITEM, {
            id: event.detail.noteId,
            from: FROM_LIBRARY,
            deeplink: createDeeplink(res),
            inSlider:true,
          })
        }else{
          window.openDialogCard(res);
        }
      })
    }

    document.addEventListener('outsideBlockLinkClick', handleOutsideBlockLinkClick);

    document.body.addEventListener('mousedown',onMouseLeftButtonDown);
    document.body.addEventListener('paste',onPaste);
    document.body.addEventListener('dragover',onDragOverListener)
    document.body.addEventListener('drop',onDropListener);

    //开始了网盘的自动恢复---比较文件的时间....
    let szEnableSync = localStorage.getItem(KEY_IS_ENABLE_SYNC) == 'true';
    let szAutoRefresh = localStorage.getItem(KEY_GLOBAL_SYNC_AUTO_REFRESH_WHEN_OPEN_APP) || 'false';
    if (szEnableSync && szAutoRefresh == 'true'){
        window.showMessageBox(t("Tips"),t("AreYouSureRefreshFromCloud"),t("Skip"),t("Refresh"),null,()=>{
          autoRestoreAutoRestore(true).then(res => {
            //不要保存首页的...
            global.g_isRestoreData = true;
            //去列表...
            onRecentClick();
          }).catch(e => {
            window.closeIndicator();
          })
        },false)
    }

    window.refreshList['updateTheme_homeIndex'] = forceUpdate;

    //--------test-------
    if (DEBUG){
      /*
      ipcInvoke('restore-from-proj-history').then(res=>{
        if (res){
          const lTime = Date.now();
          for (let i=0;i<res.length;i++){
            const item = res[i];
            if (item.id == 'init_info_0' || item.id == 'default_project_id_')continue;
            const szTitle = 'restore_'+i;
            const project = {
              id:item.id,
              doc:item.data,
              createTime: lTime,
              deleteTime: 0,
              favirateTime: 0,
              isDeleted: 0,
              isFavirated: 0,
              name: szTitle,
              searchName: szTitle,
              showName: szTitle,
              updateTime: lTime,
              viewTime: lTime,
              thumbUrl: ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[0],
            }
            //保存
            updateNote(project);
          }
        }
      })
      */
    }


    return ()=>{
      unSubscribe(EVENT_AUTO_UPDATE_IS_READY);
      unSubscribe(EVENT_SWITCH_HOME_LIST_MENU);
      unSubscribe(EVENT_UPDATE_NOTE);
      unSubscribe(EVENT_REFRESH_HOME_LEFT_MENU);
      unSubscribe(EVENT_RENAME_PAGES);
      unSubscribe(POST_MESSAGE_REFRESH_FOLDER_LIST);
      document.body.removeEventListener('mousedown',onMouseLeftButtonDown);
      document.body.removeEventListener('paste',onPaste);
      document.body.removeEventListener('dragover',onDragOverListener)
      document.body.removeEventListener('drop',onDropListener);
      document.removeEventListener('outsideBlockLinkClick', handleOutsideBlockLinkClick);
      delete window.refreshList['updateTheme_homeIndex'];
    }

  },[])

  useEffect(()=>{
    mFolderIsExpand = isExpand;
  },[isExpand])

  useEffect(() => {
    global.g_isFullscreen = isFullScreen;
  }, [isFullScreen]);

  useEffect(()=>{
    mSelectMenuItem = selectMenuItem;
    localStorage.setItem(KEY_HOME_SELECT_ITEM,selectMenuItem);
  },[selectMenuItem])

  useEffect(() => {
    if (homeLeftMenu){
      //home
      if (selectMenuItem == 'home' && homeLeftMenu.home){
        navPage('home');
        return;
      }

      //如果当前选中的菜单被隐藏了-自动切换到project
      if (selectMenuItem == 'home' && !homeLeftMenu.home){
        navPage('recent')
      }else if (selectMenuItem == 'journal' && !homeLeftMenu.journal){
        navPage('recent')
      }else if (selectMenuItem == 'tags' && !homeLeftMenu.tags){
        navPage('recent')
      }else if (selectMenuItem == 'highlights' && !homeLeftMenu.highlights){
        navPage('recent')
      }
    }

  }, [homeLeftMenu]);

  useEffect(() => {
    global.g_arrayFavorFolders.length = 0;
    const arrayFolders = arrayFavirates.filter(p=>p.isFolder);
    global.g_arrayFavorFolders.push(...arrayFolders)
  }, [arrayFavirates]);

  const refreshFolder = (nDeleteIndex=-1)=>{
    //查找所有文件夹
    allFolder().then(res=>{
      if(res.length == 0){
        res.push({
          id:'-1',
          name:t('Create folder'),
          showMore:false
        })
      }
      res.forEach((p)=>{
        p.isSelect = p.showMore = false;
      });
      res.sort((a,b)=>{
        return a.createTime - b.createTime;
      })

      var szFolderId = mLastSelectId;//使用上一个的文件//localParams.state?.folderId;
      if (nDeleteIndex != -1){
        if (nDeleteIndex < res.length){
          szFolderId = res[nDeleteIndex].id;
        }else{
          szFolderId = res[0].id;
        }
      }
      if (szFolderId != undefined){
        if ("recent" == szFolderId){
          onRecentClick();
        }else if ("folder" == szFolderId){
          onNavFolderClick();
        }else{
          var arrayTmp = res.filter(p=>p.id === szFolderId);
          if(arrayTmp.length > 0){
            arrayTmp[0].isSelect = true;
            setSelectMenuItem('');
            navigate('/home',{state:{folderId:szFolderId,folderName:arrayTmp[0].name},replace:true});
          }
        }
      }
      setArrayFolders(res);
    })
  }

  /**
   * 刷新收藏
   */
  const refreshFavor = ()=>{
    if (global.g_isNotRefreshFavor) {
      global.g_isNotRefreshFavor = false;
      return;
    }

    if (mIsRefreshFavor.current){
      return;
    }

    mIsRefreshFavor.current = true;
    getFavorList().then(async (arrayNotes:any)=>{
      var arrayFavs = arrayNotes.filter(p=>p.isDeleted===0 && !p.thumbHtml);
      //card的收藏
      var arrayCardFavs = await getCardFavorList();
      for (let i=0;i<arrayCardFavs.length;i++){
        const item = arrayCardFavs[i];
        if (!item.name){
          item.name = getCardTitle(item);
        }
      }
      arrayFavs.push(...arrayCardFavs);

      //tag收藏
      var arrayTagFavs = await getTagFavorList();
      arrayFavs.push(...arrayTagFavs);

      //board收藏
      var arrayBoardFavs = await getBoardFavorList();
      //补充projectname;
      for (let i=0;i<arrayBoardFavs.length;i++){
        const project = await getNoteById(arrayBoardFavs[i].projectId);
        arrayBoardFavs[i].name = (project?.name || t("Untitled")) +"/"+  arrayBoardFavs[i].name;
      }
      arrayFavs.push(...arrayBoardFavs);

      //customFilter的收藏
      let arrayCustomFilters = await getCustomFilterFavorList();
      arrayCustomFilters.forEach(p=>{
        p.type = 'customFilter';
      })
      arrayFavs.push(...arrayCustomFilters);

      //链接的自定义收藏
      let arrayLinks = await getLinkFavorList();
      arrayFavs.push(...arrayLinks);

      //取文件夹.
      const arrayFavorFolders = await getFavorFolderList();
      //处理一下，
      //1.如果文件夹里面有，外面的就移除.
      //2.如果文件夹里面有，外面没有，文件夹里面的移除
      for (let i=0;i<arrayFavorFolders.length;i++){
        const folder = arrayFavorFolders[i];
        if (folder.children){
          for (let j=folder.children.length-1;j>=0;j--){
            const child = folder.children[j];
            if (!child)continue;
            child.isEditable = false;
            child.isHover = child.isOpen = false;
            // if (!child.key)
            {
              child.key = child.id+'_'+generateUUID2();
            }


            //更新下里面的name...
            const item = arrayFavs.find(p=>p.id == child.id);
            if (item){
              child.name = item.name;
              if (child.thumbUrl){
                child.thumbUrl = item.thumbUrl
              }
            }

            const nIndex = arrayFavs.findIndex(p=>p.id == child.id && p.favirateTime <= child.favirateTime);
            if (nIndex == -1){
              folder.children.splice(j,1);
            }else{
              arrayFavs.splice(nIndex,1);
            }
          }
        }
      }

      arrayFavs.push(...arrayFavorFolders);

      // arrayFavs = arrayFavs.slice(0,6);
      arrayFavs.forEach(p=> {
        p.isHover = p.isOpen = false;
        p.isEditable = false;
        // if (!p.key)
        {
          p.key = p.id+'_'+generateUUID2();
        }
      });


      //排序，按收藏时间
      arrayFavs = arrayFavs.sort((a,b)=>{
        if (!a.favirateTime || !b.favirateTime)return 0;
        return b.favirateTime - a.favirateTime;
      })
      arrayFavs.sort((a,b)=>a.sort - b.sort);
      //选中之前选中的
      //当前页面是card或者draw
      if (window.location.href.includes('/card') || window.location.href.includes('/draw')){
        const selectItem = arrayFavirates.find(p=>p.isSelected);
        if (selectItem){
          arrayFavs.forEach(p=>{
            if (p.id == selectItem.id){
              p.isSelected = true;
            }
          })
        }
      }

      mArrayFavs = arrayFavs;

      setArrayFavirates(arrayFavs);

      if (isExpandFavor || mIsFirstFavor || arrayFavs.length == 1){
        setIsExpandFavor(arrayFavs.length > 0);
      }
      mIsFirstFavor = false;

      refreshExpandKeys(mExpandKeys.current);

      //处理最近--直接刷新。数据不确定
      refreshRecents();
      // var arrayNewRecents = [...arrayRecents];
      // for (let i=0;i<arrayNewRecents.length;i++){
      //   const itemRecent = arrayNewRecents[i];
      //   const item = arrayFavs.find(p=>p.id == itemRecent.id);
      //   if (item){
      //
      //   }
      // }

      // setTimeout(()=>{
      //   console.log('xxxx')
      // },100)

      mIsRefreshFavor.current = false;

    })
  }

  /**
   * 重置所有favor未选中
   */
  const resetFavorNoSelect = ()=>{
    const arrayNew = [...arrayFavirates];
    arrayNew.forEach(p=>p.isHover = p.isSelected = false);
    setArrayFavirates(arrayNew);
  }


  /**
   * 刷新最近.
   */
  const refreshRecents = async ()=>{
    /* 暂时注释*/
    const arrayProjects = await getProjectRecentsList();
    const arrayLibrarys = await getLibraryRecentsList();
    let arrayNewRecents:any = [...arrayProjects,...arrayLibrarys];
    arrayNewRecents.forEach(p=>{
      if (!p.viewTime){
        p.viewTime = p.updateTime;
      }
    })
    let arraySort = arrayNewRecents.filter(p=>p.viewTime != 1).sort((a,b)=>b.viewTime - a.viewTime);

    //当前有选中的继续保持选中
    //当前页面是card或者draw
    if (window.location.href.includes('/card') || window.location.href.includes('/draw')) {
      // if (global.g_currentRecentId) {
      //   const selectItem = arraySort.find(p => p.id == global.g_currentRecentId);
      //   if (selectItem) {
      //     arraySort.forEach(p => {
      //       if (p.id == selectItem.id) {
      //         p.isSelected = true;
      //         setSelectMenuItem('');
      //       }
      //     })
      //   }
      // }
      //直接选中第一个
      if (arraySort.length > 0 && selectMenuItem != 'home'){
        arraySort[0].isSelected = true;
      }
    }
    // if (arraySort.length == 0){
    //   setIsExpandRecent(false);//给收藏用，收藏需要用这个值...
    // }
    setArrayRecents(arraySort.slice(0,20));
  }

  /**
   * 重置所有recent未选中
   */
  const resetRecentNoSelect = ()=>{
    const arrayNew = [...arrayRecents];
    arrayNew.forEach(p=>p.isHover = p.isSelected = false);
    setArrayRecents(arrayNew);
  }

  const onMenuItemContextMenu = (szAction: any) => {
    //当前选中的
    var arrayCurrentFolders = arrayFolders.filter(p=>p.showMore);
    if(arrayCurrentFolders.length == 0)return;
    var currentFolder = arrayCurrentFolders[0];

    if ("newProject" === szAction){
      // navigate('/draw',{state:{folderId:currentFolder.id}});  why 不能跳转.....
      // onNav();

      postMessage(EVENT_NEW_PROJECT,currentFolder);
    }else if ("rename" === szAction){
      dialogNewFolderRef?.current?.onShowDialogEvent(currentFolder);
    }else if ("delete" === szAction){
      /*
      Modal.confirm({
        content:t("Confirm delete the folder"),
        onOk(){
          deleteFolder(currentFolder.id).then(res=>{
            var nDeleteIndex = arrayFolders.indexOf(currentFolder);
            refreshFolder(nDeleteIndex);
          })
        }
      })*/
      dialogMessageBoxRef?.current?.onShowDialog(t("Confirm delete"),t("Confirm delete the folder"),t("Delete"),()=>{
        deleteFolder(currentFolder.id).then(res=>{
          var nDeleteIndex = arrayFolders.indexOf(currentFolder);
          refreshFolder(nDeleteIndex);
        })
      })
    }
  }

  /**
   * 转到首页--最近
   */
  const onRecentClick = ()=>{
    var arrayTmp = [...arrayFolders];
    arrayTmp.forEach(p=>p.isSelect = false);
    mLastSelectId = 'recent';
    setArrayFolders(arrayTmp);
    setSelectMenuItem('recent');
    navigate('/home/project',{state:{folderName:t('Projects')}})

    // navigate('/home',{state:{folderName:t('Projects')}})
    postMessage(EVENT_RESET_SEARCH,{});

    resetFavorNoSelect();
    resetRecentNoSelect();

    // window.closeRightSlider();
  }

  /**
   * 转到文件夹视图
   */
  const onNavFolderClick = ()=>{
    var arrayTmp = [...arrayFolders];
    arrayTmp.forEach(p=>p.isSelect = false);
    mLastSelectId = 'folder';

    setArrayFolders(arrayTmp);
    setSelectMenuItem('folder');

    //展开或折叠
    onCollapseOrExpand();

    navigate('/home',{state:{folderId:'-2',folderName:t("Folders")}})
  }

  /**
   * 折叠或展开
   */
  const onCollapseOrExpand = ()=>{
    setIsExpand(!isExpand);
  }

  /*折叠或展开收藏*/
  const onCollapseOrExpandFavor = ()=>{
    setIsExpandFavor(!isExpandFavor)
  }

  /**
   * 转到文件夹点击的条目
   * @param nIndex
   */
  const onNavFolderItem = (nIndex)=>{
    if (nIndex == -1)return;
    setSelectMenuItem('')
    var arrayNew = [...arrayFolders];
    var item = arrayNew[nIndex];
    mLastSelectId = item.id;

    if (item.id == '-1'){
      dialogNewFolderRef?.current?.onShowDialogEvent();
    }else{
      arrayNew.forEach(p=>p.isSelect = false);
      item.isSelect = true;
      navigate('/home',{state:{folderId:item.id,folderName:item.name},replace:true});
    }
    setArrayFolders(arrayNew);
  }

  /**
   * 文件夹点击...。切换到当前分类的文件夹....
   * @param e
   */
  const onFolderItemClick = (e)=>{
    var nIndex = e.currentTarget.dataset.index;
    onNavFolderItem(nIndex);
  }

  const onFolderItemEnter = (e)=>{
    var nIndex = e.currentTarget.dataset.index;
    var arrayNew = [...arrayFolders];
    var item = arrayNew[nIndex];
    if(item.id == '-1')return;
    item.showMore = true;
    setArrayFolders(arrayNew);
  }
  const onFolderItemLeave = (e)=>{
    var nIndex = e.currentTarget.dataset.index;
    var arrayNew = [...arrayFolders];
    var item = arrayNew[nIndex];
    item.showMore = false;
    setArrayFolders(arrayNew);
  }

  /**
   * 模板点击--NEW。。。
   */
  const onTemplateItemClick = (szFileName)=>{
    var szFilePath = templatePathPerfix()+"/"+szFileName+".template";
    ipcInvoke("read-file",{filePath:szFilePath}).then(res=>{
      const jsonObj = JSON.parse(res);
      //打开画布
      var szFolderId = -1;
      navigate(getDrawPath(),{state:{importNoteData:jsonObj,isReadOnlyState:false,folderId:szFolderId}});
    })
  }

  /**
   * 转到draw....
   * @param strData
   * @param filePath
   */
  window.onNavigateDraw = async (strData:any,filePath:any)=>{
    const jsonObj = JSON.parse(strData);
    if (filePath.toLowerCase().endsWith('pcanvasx') || !jsonObj.info?.isReadOnlyStatus){
      if (jsonObj.info?.isBackupMode){
        if (localStorage.getItem(KEY_MACHINEID) != jsonObj.info.deviceId){
          dialogMessageBoxRef.current?.onShowDialogWithoutCancel(t("NoPermissions"),t("ApologiesNoPermission"),t("See plans"),()=>{
            postMessage(EVENT_SHOW_DESKTOP_PRO_VIP, {from:DESKTOP_PRO_FROM_IMPORT_BACKUP_FILE})
          });
          return;
        }
      }else{
        if (await hasBeyondFreeLimit()){
          postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
          return;
        }
      }
    }

    jsonObj.folderId='';//导入的置空....
    const szFilePath = filePath;
    //打开画布
    var szFolderId = ''
    navigate(getDrawPath(),{state:{importNoteData:jsonObj,isReadOnlyState:jsonObj.info?.isReadOnlyStatus,folderId:szFolderId}});
  }

  /**
   * 供外部跳转
   * @param szPath
   * @param params
   */
  window.navigate = (szPath,params)=>{
    window.closeAllDialog();
    navigate(szPath,{state:params});
  }
  /**
   * 原始的。。。。
   * @param szPath
   * @param params
   */
  window.navigateOrigin = (szPath,params)=>{
    navigate(szPath,params);
  }

  /**
   * 转到页面
   * @param szPageName
   */
  window.navPage = (szPageName:any)=>{
    navPage(szPageName);
  }

  /**
   * 转到标签页面.
   * @param tag
   */
  window.navPageTag = (tag)=>{
    setSelectMenuItem('tags');
    if (tag){
      navigate("/home/tagItemList",{state:{tagItem:tag,from:'nav'}});
    }else{
      navigate("/home/tags",{});
    }

  }

  /**
   * 关闭所有的弹出窗口
   */
  window.closeAllDialog = ()=>{
    window.closeDialogPdfAnno();
    window.closeDialogVideoAnno();
    window.closeVideoNotes();
    window.closeUnpinDialogPdf();
    window.closeUnpinDialogVideos();
    closeEditor();//关闭
  }

  const onShowStoreTips = ()=>{
    localStorage.setItem(SYS_CONFIG_KEY_STORE_TIPS,'true');
    // setTimeout(()=>{
    //   window.showMessageBox(t("Set default storage location"),t("PleaseSetDefaultStorage"),t("Dismiss"),t("Set storage location"),null,()=>{
    //     //设置默认目录
    //     dialogSetRef?.current?.onDialogShow(true);
    //   })
    // },100)
  }

  /**
   * 保存导入的项目
   * @param importData
   */
  window.saveImportProject = async (importData:any)=>{
    global.g_isImportProject = true;
    let szNewProjectId = crypto.randomUUID();
    //查找所有元素-修改内部的链接
    if (importData.info.originProjectId){
      let szNewImportData = JSON.stringify(importData);
      szNewImportData = szNewImportData.replaceAll(importData.info.originProjectId,szNewProjectId);
      importData = JSON.parse(szNewImportData);
    }

    importData.info.isImport = true;//标记为import
    let pageDatas = importData;

    //缩略图...导出用...
    let mThumbUrl = importData.info?.thumbUrl;
    if (ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1.includes(mThumbUrl)){
      mThumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[0];
    }

    //保存笔记的图片到本地...
    await ipcInvoke('save-image-to-local', JSON.stringify(pageDatas.notesImage));
    //保存插入的文件到本地
    if (pageDatas.files && pageDatas.files.length > 0) {
      await ipcInvoke('write-base64-files', JSON.stringify(pageDatas.files))
    }

    //兼容旧的数据--图片以文件方式保存 20241119
    await saveOldImportImageToLocalFile(pageDatas)

    //分离数据到library....
    await updateCanvasToLibrary(pageDatas, false, (fProgress: any) => {
      // setLoadingTips(Math.round(fProgress * 100) + '%')
      // window.showIndicator(Math.round(fProgress * 100) + '%');
    },null);

    //加载笔记，文件===
    await loadNotesElement(pageDatas,true);

    //add update time
    const dtNow = Date.now();
    for (let i = 0; i < pageDatas.canvas.length; i++) {
      const item = pageDatas.canvas[i];
      item.updateTime = dtNow;
      item.hasUpdate = true;
      if (item.isFolder) {
        for (let j = 0; j < item.children.length; j++) {
          item.children[j].updateTime = dtNow;
        }
      }
    }
    for (let i = 0; i < pageDatas.notes.length; i++) {
      const item = pageDatas.notes[i];
      item.updateTime = dtNow;
      item.hasUpdate = true;
      if (item.isFolder) {
        for (let j = 0; j < item.children.length; j++) {
          item.children[j].updateTime = dtNow;
        }
      }
    }
    let mTitle = importData.info.title;
    // setTitle(importData.info.title);


    //这里先保存一下。以免有些东西找不到。。。
    let nIndex:any = getIntValue(localStorage.getItem(KEY_PROJECT_THUMB_INDEX), 0);
    if (nIndex < 0 || nIndex > ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length) {
      nIndex = 0;
    }

    delete importData.notesImage;
    delete importData.librarys;
    delete importData.audioHighlights;
    delete importData.cardHighlights;
    delete importData.videoHighlights;
    delete importData.annotations;
    delete importData.transcripts;

    const lTime = Date.now();
    const szTitle = mTitle;
    const project = {
      createTime: lTime,
      deleteTime: 0,
      doc: importData,
      favirateTime: 0,
      id: szNewProjectId,
      isDeleted: 0,
      isFavirated: 0,
      name: szTitle,
      searchName: szTitle,
      showName: szTitle,
      updateTime: lTime,
      viewTime: 0,
      tags:[],
      thumbUrl: mThumbUrl || ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nIndex],
    }
    localStorage.setItem(KEY_PROJECT_THUMB_INDEX, (nIndex+1) % 12 + '');
    project.saveTimes = 0;
    project.name = project.showName = project.searchName = szTitle;
    project.updateTime =  lTime;
    await updateNote(project);

    //几s后才关闭，这有些PDF接收太慢了。。。。
    setTimeout(()=>{
      global.g_isImportProject = false;
    },5000)

    return project;
  }

  /**
   * 导入文件到库----
   * @param selectFile
   */
  window.importFileToLibrary = async (selectFile,importMode,callback:any,bSaveToLirary=true)=>{
    await copyOneFile(selectFile,importMode,callback,bSaveToLirary);
  }

  window.importFileToLibraryWithReturn = async (selectFile,importMode,bSaveToLirary=true)=>{
    return new Promise<any>(resolve => {
      copyOneFile(selectFile,importMode,(data)=>{
        resolve(data)
      },bSaveToLirary);
    })
  }

  /**
   * 旧的导入图片，以文件方式保存在本地
   * @param pageDatas
   */
  const saveOldImportImageToLocalFile = async (pageDatas:any)=>{
    for (let i=0;i<pageDatas.canvas.length;i++){
      const item = pageDatas.canvas[i];
      if (!item.drawJson)continue;
      const files = item.drawJson.files;
      const arrayFiles = Object.values(files);
      for (let j=0;j<arrayFiles.length;j++){
        const value:any = arrayFiles[j];
        if(value.dataURL && !isSvg(value.mimeType)){
          const szFileName = value.id + "."+extFromMineType(value.mimeType);
          const arraySplits = value.dataURL.split(',');
          if (arraySplits.length > 1){
            const arrayFiles = [{fileName:szFileName,data:arraySplits[1]}]
            await ipcInvoke('write-base64-files',JSON.stringify(arrayFiles));
          }
          value.dataURL = '';//置空.
        }
      }
    }
  }

  /**
   * 从card library中替换notes.
   * @param pageData
   */
  const replaceNotesFromLibrary = async (pageData: any) => {
    if (!pageData.notes) return;

    for (let i = 0; i < pageData.notes.length; i++) {
      const card = await getCardById(pageData.notes[i].key);
      if (card) {
        pageData.notes[i].title = card.name;
        pageData.notes[i].editValue = card.name;
        pageData.notes[i].noteDataDoc = card.doc;
      }
    }
  }

  /**
   * 加载笔记元素
   * @param pageData
   */
  const loadNotesElement = async (pageData: any,isImport=false) => {
    await replaceNotesFromLibrary(pageData);
    const arrayAllElements:any = [];

    loopAllNode(pageData.canvas,(item)=>{
      if (item.drawJson?.elements){
        arrayAllElements.push(...item.drawJson.elements);
      }
    })

    //这里删除，空白的卡片...
    if (isArray(pageData.notes)){
      for (let k=(pageData.notes.length-1);k>=0;k--){
        const card = await getCardById(pageData.notes[k].key);
        const isInCard = arrayAllElements.some(p=>p.id == card?.id || p.customData?.generationData?.id == card?.id)
        if (card){
          if (card.isDeleted == 1 || (isCardEmptyCard(card) && !isInCard)){
            pageData.notes.splice(k,1);
          }
        }
      }
    }

    await loopAllNodeAsync(pageData.canvas,async (item)=>{
      if (item.drawJson?.elements){
        await loadElementNotes(item.drawJson.elements, pageData.notes,isImport);
      }
    })

    return 'ok'
  }

  /**
   * 加载元素中的笔记
   * @param elements
   * @param notes
   */
  const loadElementNotes = async (elements: any, notes: any,isImport=false) => {
    if (!elements) return;
    for (let i = 0; i < elements.length; i++) {
      let item = elements[i];
      if (item.type == 'iframe' && ('customData' in item)) {

        if (item.customData.generationData.type == 'pdfAnno'  || isCardAnnoElement(item)) {
          //去library查看有没有
          const pdfAnno = await getCardById(item.id);
          if (pdfAnno){
            item.customData.generationData.pdfData.comment = pdfAnno.comment;
            if (isCardAnnoElement(item)){
              item.customData.generationData.pdfData = pdfAnno;
            }
          }
          //pdf注记
          if (isPdfAnnoElement(item)){
            item.customData.generationData.html = createPdfAnnoTextElement(item.customData.generationData.pdfData);
          }

        }
        else {
          if (isFileElement(item)){
            //文件...判断文件是否存在
            if (item.customData.generationData?.isAbsolutePath){
              item.customData.generationData.isFileExist = await ipcInvoke('is-file-exist',{filePath:item.customData.generationData.fileName})
            }
          }

          const card: any = await getCardById(item.customData.generationData.id);
          if (card) {
            if (card.isDeleted){
              //已经被删除，标记删除...
              item.isDeleted = true;
            }
            //region card
            item.customData.generationData.id = card.id;
            if (!isCardAnnoElement(item) && (card.type == 'card' || card.type == 'journal')) {
              item.customData.generationData.name = card.name;
              item.customData.generationData.html = card.doc;//createNoteElementByNote(card.name,card.doc);
              item.customData.generationData.type = 'note';
              item.customData.generationData.isEditable = false;
              item.customData.generationData.isHidden = card.isHidden;
              item.customData.generationData.journalTime = card.journalTime;
              item.customData.generationData.libraryType = card.type;
              if (isDefaultBackgroundColor(item.backgroundColor)) {
                item.backgroundColor = getNoteElementBackgroundColor()
              }
              if (card.isDeleted /*|| isCardEmptyCard(card)*/) {
                //卡片删除，删除左侧
                item.isDeleted = true;
                for (let j = 0; j < notes.length; j++) {
                  const note = notes[j];
                  if (note.key == item.id || note.key == item.customData.generationData.id) {
                    notes.splice(j, 1);
                    break;
                  }
                }
              }
            } else {
              if (isVideoAnnoElement(item) || isAudioAnnoElement(item)){
                //从pdfhightlight 中更新这个notes
              }else{
                item.customData.generationData.name = card.name;
                item.customData.generationData.fileName = card.fileName;
                item.customData.generationData.html = createFileElementHtml(card.id, card.fileName, card.name, card.thumbImage);
                item.customData.generationData.type = 'file';
              }
              //--文件类型的.给予名称
              item.name = card.name;

              if (isDefaultBackgroundColor(item.backgroundColor)) {
                item.backgroundColor = getNoteElementBackgroundColor()
              }
              if (isFileVideoElement(item)){
                if (isImport){
                  //是导入的，
                  if (item.videoNotes){
                    //保存到数据库
                    const highlight = {
                      id:item.customData.generationData.id,
                      type:'video',
                      libraryId:item.customData?.generationData?.id,
                      name:item.customData?.generationData?.showName,
                      fileName:item.customData?.generationData?.fileName,
                      data:item.videoNotes
                    }
                    updateHighlight(highlight);
                  }
                }else{
                  //从数据库读取videoNotes
                  let highlight = await dbGetHighlight(item.id);
                  if (!highlight){
                    highlight = await dbGetHighlight(item.customData?.generationData?.id);
                  }
                  if (highlight){
                    item.videoNotes = highlight.data;
                    videoCache.set(item.id,highlight.data);
                  }else{
                    //没有highlight...但是文件上带...
                    if (item.videoNotes){
                      //保存到数据库
                      const highlight = {
                        id:item.customData.generationData.id,
                        type:'video',
                        libraryId:item.customData?.generationData?.id,
                        name:item.customData?.generationData?.showName,
                        fileName:item.customData?.generationData?.fileName,
                        data:item.videoNotes
                      }
                      updateHighlight(highlight);
                    }
                  }
                }
              }
            }
            //endregion
          } else {
            //没有card
            if (isNoteElement(item)) {
              for (let j = 0; j < notes.length; j++) {
                const note = notes[j];
                if (note.key == item.id || note.key == item.customData.generationData.id) {
                  notes.splice(j, 1);
                  break;
                }
              }
              //element 也标记为删除
              item.isDeleted = true;
            }
          }
        }
      }else if (isEmbeddableElement(item) && isSupportVideoAnnoUrl(item.link)){
        if (isImport) {
          //是导入的，
          if (item.videoNotes) {
            const src = getEmbedLink(toValidURL(item.link || ""));
            //保存到数据库
            const highlight = {
              id:item.id,
              url:item.link,
              name:item.name || '',
              data:item.videoNotes,
              type:'youtube',
              thumbImage:getYoutubeThumbUrl(src?.videoId)
            }
            updateHighlight(highlight);
          }
        }else{
          //从数据库读取videoNotes
          let highlight = await dbGetHighlight(item.id);
          if (!highlight){
            highlight = await dbGetHighlight(item.customData?.generationData?.id);
          }
          if (highlight){
            item.videoNotes = highlight.data;
            videoCache.set(item.id,highlight.data);
            if (highlight.isDeleted == 1){
              item.isDeleted = true;
            }
          }else{
            if (item.videoNotes) {
              const src = getEmbedLink(toValidURL(item.link || ""));
              //保存到数据库
              const highlight = {
                id:item.id,
                url:item.link,
                name:item.name || '',
                data:item.videoNotes,
                type:'youtube',
                thumbImage:getYoutubeThumbUrl(src?.videoId)
              }
              updateHighlight(highlight);
            }
          }
        }
      }else if(isImageElement(item)){
        const library = await getCardById(item.customData?.generationData?.id);
        if (library){
          item.name = library.name;
          item.customData.generationData.name = library.name;
        }
      }
    }
  }

  /**
   * 更改左侧栏的标签页
   */
  const onShowChangeTabTip = ()=>{
    window.showMessageBox(t("NewFeatureCustomizeHome"),t("YouCanPersonalize"),t("RemindMeLater"),t("CustomizeNow"),()=>{
      //以后提醒
      localStorage.setItem(KEY_CUSTOMIZE_HOME_REMIND_ME_LATER,'true');
    },()=>{
      localStorage.setItem(KEY_CUSTOMIZE_HOME_REMIND_ME_LATER,'false');
      //显示设置
      window.showSettingDialog('homePreference');
    })
    localStorage.setItem(KEY_CUSTOMIZE_HOME_20241209,'true');
  }

  /**选择文件后这里开始导入*/
  const onImportNoteData = async (strData,filePath)=>{
    window.showIndicator();

    const jsonObj = JSON.parse(strData);

    if (filePath.toLowerCase().endsWith('pcanvasx') || !jsonObj.info?.isReadOnlyStatus){
      if (jsonObj.info?.isBackupMode){
        if (localStorage.getItem(KEY_MACHINEID) != jsonObj.info.deviceId){
          dialogMessageBoxRef.current?.onShowDialogWithoutCancel(t("NoPermissions"),t("ApologiesNoPermission"),t("See plans"),()=>{
            postMessage(EVENT_SHOW_DESKTOP_PRO_VIP, {from:DESKTOP_PRO_FROM_IMPORT_BACKUP_FILE})
          });
          return;
        }
      }else{
        if (await hasBeyondFreeLimit()){
          window.closeIndicator();
          postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
          return;
        }
      }
    }

    jsonObj.folderId='';//导入的置空....
    const szFilePath = filePath;
    //打开画布
    var szFolderId = "-1";
    //不打开，给个提示----!20250114----
    // navigate(getDrawPath(),{state:{importNoteData:jsonObj,isReadOnlyState:jsonObj.info?.isReadOnlyStatus,folderId:szFolderId}});
    window.saveImportProject(jsonObj).then(res=>{
      window.closeIndicator();
      //刷新
      postMessage(EVENT_NOTE_CHANGED)

      if (mMapCallback.current['importProject']){
        mMapCallback.current['importProject'](res);
      }else{
        //这里给个提示
        window.showMessageBox(t("Tips"),t("ProjectHasImport"),t("Cancel"),t("Open"),null,()=>{
          //open....
          navigate(getDrawPath(),{state:{noteData:res,searchKey:''}});
        })
      }
    })
  }

  /**
   * 导入项目...
   * @param callback
   */
  window.importProject = async (callback:any)=>{
    mMapCallback.current['importProject'] = callback;
    if (await hasBeyondFreeLimit()){
      postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''});
      return;
    }
    setFileImportAccept(".pcanvas,.pcanvasx");
    setTimeout(()=>{
      fileInputRef.current?.click();
    },100);
  }

  let importConfig = {};
  if (!isWeb()) {
    importConfig = window.IPC.getConvertToken();
  }

  const editor = useEditor({
    injectCSS: true,
    extensions: [
        ...getTiptapExtension(null,'')
    ],
    parseOptions: {
      preserveWhitespace: 'full',
    },
  });

  window.publicEditor = editor;
  window.editorForMd = editor;


  window.exportMarkdown = async (data)=>{
    // window.showProgress(t("Exporting"))

    editor?.commands.setContent(data.doc);
    /*
    editor?.chain().export({
      format: 'md',
      onExport(context) {
        const { blob, error } = context
        if(error){
          noteServer.openTip("error", t("ExportMarkdownFail"));
          return;
        }
        blob.arrayBuffer().then(arrayBuffer => {
          window.closeProgress();

          ipcSend('save-markdown-to-system', arrayBuffer, data.name)
        });
      },
    })*/


    try {
      // 使用自定义序列化器将文档转换为 Markdown
      const doc = editor.state.doc;
      let { markdown, images } = serializeProseMirrorToMarkdown(doc);
      if (!images || images.length == 0){
        // 编码为 ArrayBuffer
        const encoder = new TextEncoder();
        const arrayBuffer = encoder.encode(markdown).buffer;

        window.closeProgress();
        ipcSend("save-markdown-to-system", arrayBuffer, getCardTitle(data));
      }else{
        //
        const zip = new JSZip();
        const assetFolderName = `${data.name}-assets`;
        const assetFolder = zip.folder(assetFolderName);

        // 替换 markdown 中的图片路径为卡片独立的 assets 文件夹
        for (const img of images) {
          try {
            const blob = await downloadImageAsBlob(img.src);
            if (blob && assetFolder) {
              assetFolder.file(img.filename, blob);
              // 替换 markdown 中的图片路径
              markdown = markdown.replace(
                  `asset/${img.filename}`,
                  `${assetFolderName}/${img.filename}`
              );
            }
          } catch (error) {
            console.error(`Failed to download image: ${img.src}`, error);
          }
        }

        // 添加 markdown 文件到 zip
        zip.file(`${getCardTitle(data)}.md`, markdown);
        // 生成 zip 文件
        const zipBlob = await zip.generateAsync({ type: "blob" });
        const arrayBuffer = await zipBlob.arrayBuffer();

        window.closeProgress();
        const result: any = await ipcInvoke(
            "save-zip-to-system",
            arrayBuffer,
            `${getCardTitle(data)}.zip`
        );

        if (result?.success) {
          message.info(t("Markdown exported successfully"));
        } else if (!result?.canceled) {
          noteServer.openTip("error", t("ExportMarkdownFail"));
        }
      }
    } catch (error) {
      console.error("Export markdown error:", error);
      noteServer.openTip("error", t("ExportMarkdownFail"));
      window.closeProgress();
    }
  }

  /**
   * 导入md 文件
   * @param file
   */
  window.importMarkdown = (file,callback:any)=>{
    importMarkdown(file,callback);
  }
  /**
   * markdown导入----
   */
  window.importMarkdownMultiple = (callback:any = null)=>{
    importMarkdownMultipe(callback);
  }

  let intervalImport:any;
  const importMarkdownMultipe = async (callback:any = null) => {

    ipcInvoke('import-markdown').then(async r => {
      if (!r) {
        return;
      }
      window.showProgress(t("Importing..."))

      // 展开所有文件（包括 zip 中的 md 文件）
      const allFiles: { path: string; content?: string; name?: string }[] =
          [];

      for (const filePath of r) {
        if (filePath.toLowerCase().endsWith(".zip")) {
          // 处理 zip 文件
          const mdFiles = await processZipImport(filePath);
          for (const mdFile of mdFiles) {
            allFiles.push({
              path: filePath,
              content: mdFile.content,
              name: mdFile.name,
            });
          }
        } else {
          // 普通 md 文件
          allFiles.push({ path: filePath });
        }
      }

      if (allFiles.length === 0) {
        window.closeProgress();
        return;
      }

      setProgress(0)

      let completeNum = 0
      let lock = false;
      const arrayCards:any = [];

      intervalImport=setInterval(async () => {
        if(completeNum== allFiles.length){
          clearInterval(intervalImport);
          window.closeProgress();

          if (callback){
            callback(arrayCards)
          }else{
            window.showMessageBox(t("Import complete"),t("YourCardsHasBeenImport"),'',t("View"),null,()=>{
              //转到library
              postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'library'})
            })
          }

          postMessage(EVENT_REFRESH_LIBRARY_LIST);

          return;
        }
        if (!lock) {
          lock=true;
          editor?.commands.setContent('');

          // 使用本地md解析器解析
          const currentFile = allFiles[completeNum];
          let fileContent: string;
          let fileName: string;

          if (currentFile.content || allFiles[completeNum].path.toLowerCase().endsWith('.zip')){
            // 来自 zip 文件的内容
            fileContent = currentFile.content;
            fileName = currentFile.name || "untitled.md";
          }else{
            const fileInfo = window.IPC.getFileInfoByPath(allFiles[completeNum].path);
            fileName = (fileInfo.fileName);
            fileContent = window.IPC.fsReadFileSync(allFiles[completeNum].path, 'utf-8');
          }

          // 解析节点内容
          try{
            handleImportMarkdown(editor,fileContent)
            const html = imgServer.parserImgFromHtml(editor?.getHTML() as string);
            const card = await updateCard({
              id:generateUUID2(),
              type:'card',
              name:getFileNameWithoutExt(fileName),
              doc:html
            });
            arrayCards.push(card);
          }catch (e) {

          }

          completeNum += 1
          let processNow=Math.floor((completeNum / allFiles.length) * 100)
          setProgress(processNow)
          window.updateProgress(t("Importing")+'   '+processNow+'%');
          lock=false;
        }
      }, 200)
    })
  }


  /** 导入Markdown */
  const importMarkdown = async (file,callback) => {

    window.showProgress(t("Importing..."))
    // 使用本地文件进行解析
    // const fileBuffer = window.IPC.fsReadFileSync(file.path);
    // const fileInfo = window.IPC.getFileInfoByPath(file.path);
    // const blob = new Blob([fileBuffer], {type: 'text/markdown'});
    // file = new File([blob], fileInfo.fileName, {
    //   type: 'text/markdown',
    // })
    editor?.commands.setContent('')

    // 使用本地md解析器解析
    const fileInfo = window.IPC.getFileInfoByPath(file.path);
    const fileContent = window.IPC.fsReadFileSync(file.path, 'utf-8');

    // 解析节点内容
    try{
      handleImportMarkdown(editor,fileContent);

      const html = imgServer.parserImgFromHtml(editor?.getHTML() as string);
      await updateCard({
        id:generateUUID2(),
        type:'card',
        name:getFileNameWithoutExt(fileInfo.fileName),
        doc:html
      });
    }catch (e) {

    }

    window.closeProgress();

    if (callback){
      callback();
    }else{
      window.showMessageBox(t("Import complete"),t("YourCardsHasBeenImport"),'',t("View"),null,()=>{
        //转到library
        postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'library'});
      })
    }


    /*
    editor?.chain()
        .import({
          file,
          async onImport(context:ImportContext) {
            if (!context.error){
              // 对content进行处理，转化为pnote需要的格式
              context.setEditorContent()
              const html = imgServer.parserImgFromHtml(editor?.getHTML() as string);
              await updateCard({
                id:generateUUID2(),
                type:'card',
                name:getFileNameWithoutExt(fileInfo.fileName),
                doc:html
              });
              window.closeProgress();

              window.showMessageBox(t("Import complete"),t("YourCardsHasBeenImport"),'',t("View"),null,()=>{
                //转到library
                postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'library'})
              })

            }else{
              //有错...
              // window.showMessageBoxTips(t("Import"),t("ImportMdFail"),t("Ok"));
            }
          },
        })
        .run();

     */
  }

  /**
   * 复制一个文件....
   * @param selectedFile
   * @param arrayNewDatas
   */
  const copyOneFile = async (selectedFile:any,importMode:'linkMode'|'importMode' = "importMode",callback:any,bSaveToLibrary=true)=>{
    if (isVideo(selectedFile.path)){
      const nVideoCount = await beyondFreeVideoLimit();
      if (!hasLicense() && !hasDesktopBaseLicense() &&  nVideoCount){
        window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), ()=>{
          window.closeProgress();
        }, () => {
          window.closeProgress();
          if (isZh()) {
            ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
          }else {
            ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
          }
        })
        window.closeProgress();
        return;
      }
    }
    if (isPdf(selectedFile.path)){
      let bPdfCount = await beyondFreePdfLimit();
      if (!hasLicense() && !hasDesktopBaseLicense() &&  bPdfCount){
        window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), ()=>{
          window.closeProgress();
        }, () => {
          window.closeProgress();
          if (isZh()) {
            ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
          }else {
            ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
          }
        })
        window.closeProgress();
        return;
      }
    }
    let res = selectedFile.path;
    let isAbsolutePath = true;
    if (importMode == 'importMode' && !selectedFile.sandboxPath){//不是沙箱路径
      isAbsolutePath = false;
      res = await ipcInvoke('copy-file',{filePath:selectedFile.path});
    }
    if (selectedFile.sandboxPath){
      res = selectedFile.name;
      isAbsolutePath = false;
    }
    let szImgBase64:any = '';
    let szType = 'file';
    if (isPdf(selectedFile.path)){
      szImgBase64 = await getPdfImageThumb(getLocalFilePath(res,isAbsolutePath));
      szType = 'pdf'
    }else if (isVideo(selectedFile.path)){
      szImgBase64 = await getVideoImageThumb(getLocalFilePath(res,isAbsolutePath));
      szType = 'video';
    }else if (isImage(selectedFile.path)){
      szType = 'image'
    }else if (isAudio(selectedFile.path)){
      szType = 'audio'
    }

    const szId = generateUUID2();
    if (szImgBase64){
      //保存到本地
      await ipcInvoke('write-base64-image',{imgBase64:szImgBase64,fileName:(szId+'.png')})
      szImgBase64 = 'localfile://'+szId+'.png';
    }

    const item = {
      id:szId,
      name:getFileNameWithoutExt(res),
      fileName:res,
      type:szType,
      thumbImage:szImgBase64,
      createTime:Date.now(),
      isAbsolutePath:isAbsolutePath
    }
    if (bSaveToLibrary){
      await updateCard(item);
      //刷新列表
      postMessage(EVENT_REFRESH_LIBRARY_LIST);
      window.globalRefreshList('refreshLibraryList');
    }

    window.closeProgress();

    if (callback){
      callback(item);
    }else{
      window.onShowMessageTip(t("Import complete"),()=>{
        //转到library
        postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'library'})
      })
    }
  }

  window.createUrlNewLibraryItem = async (szUrl:any)=>{
    let src = getEmbedLink(toValidURL(szUrl || ""));
    let szType = '';
    let szName = '';
    if (isYoutubeUrl(szUrl)){
      szType = 'youtube'
    }else if (isBilibiliUrl(szUrl)){
      szType = 'bilibili';
    }else if (isBaiduVideoUrl(szUrl)){
      szType = 'baidu';
      szName = getBaiduVideoNameByUrl(szUrl);
    }

    const card = {
      id:generateUUID2(),
      name:szName,
      type:szType,
      fileName:szUrl,
      isDeleted:0,
      createTime:Date.now(),
      thumbImage:isYoutubeUrl(szUrl)?getYoutubeThumbUrl(src?.videoId):''
    }
    //判断highlight中是否有
    const dbHighlight = await dbGetHighlight(card.id);
    if (dbHighlight){
      card.name = dbHighlight.name;
      card.thumbImage = dbHighlight.thumbImage;
    }
    await updateCard(card);

    if (isBilibiliUrl(szUrl)) {
      apiBilibiliCover(szUrl).then(res => {
        //如果获取到缩略图，这里再更新一下...
        card.name = res.title;
        card.thumbImage = res.pic;
        updateCard(card).then(r=>{
          postMessage(EVENT_REFRESH_LIBRARY_LIST);
          window.globalRefreshList();
        });
      })
    }

    //刷新列表
    postMessage(EVENT_REFRESH_LIBRARY_LIST);

    return card;
  }

  /**
   * 转到页面
   */
  const navPage = (szPageName:any,id:any = null)=>{
    // window.closeRightSlider();

    resetFavorNoSelect();
    resetRecentNoSelect();
    if (szPageName == 'journal'){
      setSelectMenuItem('journal');
      navigate("/home/journal",{state:{id:id},replace:true});
      history.replaceState(null,"","");
    }else if (szPageName == 'library'){
      setSelectMenuItem('library');
      navigate("/home/library");
    }else if (szPageName == 'tags'){
      setSelectMenuItem('tags');
      navigate("/home/tags",{state:{tagItem:'all'}});
    }else if (szPageName == 'highlight'){
      setSelectMenuItem('highlight');
      navigate("/home/highlight");
    }else if (szPageName == 'recent'){
      onRecentClick();
    }else if (szPageName == 'home'){
      if (!window.location.href.includes('/defaultProject')){
        setSelectMenuItem('home');
        navigate("/home/defaultProject")
      }
    }else if (szPageName == 'task'){
      setSelectMenuItem('task');
      navigate('/home/task');
    }else if (szPageName == 'property') {
      setSelectMenuItem('property');
      navigate('/home/property');
    }
  }

  /**
   * 备份DB到文件路径
   */
  window.backupDb = ()=> {
    return new Promise(async (resolve) => {
      if (window.saveNotes){
        //如果当前是draw页面，保存一下当前的.
        await window.saveNotes();
      }
      //写入当前的版本号.
      await updateSysConfig(KEY_APP_VERSION,mAppVersion.current);

      const blobDb = await exportDb((progress: any) => {
        // const fProgress = (progress.completedRows / progress.totalRows) / 2;
        // console.log('export progress,'+fProgress)
      });

      var reader = new FileReader();
      reader.onload = function (result) {
        ipcInvoke('backup-db-tofile', {
          stream: result.target.result,
        }).then(res=>{
          //刷新菜单时间....
          window.refreshSyncMenu();
          resolve('ok');
        }).catch(res=>{
          resolve('error')
        })
      }
      reader.readAsArrayBuffer(blobDb);
    })
  }

  /**
   * 纯自动恢复....
   * 是最新的才恢复，不是不恢复.
   * 自动同步，同步，恢复，自动恢复
   */
  const autoRestoreAutoRestore = (bForceRefresh = false)=>{
    return new Promise((resolve,reject) => {
      ipcInvoke('auto-restore-db').then(async (data: any) => {
        if (data) {
          if (!data.isSelfVersionNew){
            window.showMessageBox(t("Tips"), t("RestoreCheckTips"), t("Cancel"), t("Update"), null, () => {
              if (isZh()){
                ipcSend("open-url", import.meta.env.VITE_HTTP_APP_DOWNLOAD_ZH);
              }else{
                ipcSend("open-url", import.meta.env.VITE_HTTP_APP_DOWNLOAD);
              }
            })
            reject('not new')
            return;
          }

          if (data.isPanNew || bForceRefresh){//只有最新的才刷新...
            global.g_isAutoRestore = true;
            window.showIndicator(("RefreshFromCloud")+'...');
            setTimeout(()=>{
              //最多20s....恢复
              global.g_isAutoRestore = false;
            },20000);
            //云盘数据是最新的，直接恢复.
            await restoreUseCloud(data);
            global.g_isAutoRestore = false;
            //延迟1s后关闭
            setTimeout(()=>{
              window.closeIndicator();
            },1500)
            resolve('ok');
          }else{
            reject('not new')
          }
        } else {
          message.error(t("CloudFolderNotFound"));
          reject('err');
        }
      })
    })
  }

  /**
   * 自动恢复
   */
  const autoRestore = async ()=>{
    return new Promise((resolve,reject) => {
      ipcInvoke('auto-restore-db').then(async (data: any) => {
        if (data) {
          if (!data.isSelfVersionNew){
            window.showMessageBox(t("Tips"), t("RestoreCheckTips"), t("Cancel"), t("Update"), null, () => {
              if (isZh()){
                ipcSend("open-url", import.meta.env.VITE_HTTP_APP_DOWNLOAD_ZH);
              }else{
                ipcSend("open-url", import.meta.env.VITE_HTTP_APP_DOWNLOAD);
              }
            })
            reject('not new')
            return;
          }

          if (data.isPanNew || data.isEqual) {//时间>或者=都刷新.
            window.showMessageBox(t("Tips"), t("AllLocalDataWillBeOverwrite"), t("Cancel"), t("UseCloudDataRestore"),null, async ()=>{
              window.showProgress(t("Refreshing"),'column');
              //直接转到项目列表...
              onRecentClick();
              await sleep(100);

              //云盘数据是最新的，直接恢复.
              await restoreUseCloud(data);
              resolve('ok');
            });
          } else {
            //是否强制恢复.
            window.showMessageBox(t("Tips"), t("CloudDataMaybeNotNew"), t("Cancel"), t("UseCloudDataRestore"), ()=>{
              reject('cancel');
            }, async () => {
              window.showProgress(t("Refreshing"),'column');
              //直接转到项目列表...
              onRecentClick();
              await sleep(100);

              await restoreUseCloud(data);
              resolve('ok');
            });
            // message.error(t('AppDataNewSaveFirst'));
          }
        } else {
          message.error(t("CloudFolderNotFound"));
          reject('err');
        }
      })
    })
  }

  /**
   * 使用云盘数据恢复
   * @param arrayBufs
   */
  const restoreUseCloud = async (data:any)=>{
    //云盘中的文件最新
    return new Promise(async (resolve) => {
      //恢复注记文件....
      ipcInvoke('auto-restore-anno');
      const blob = new Blob([new Uint8Array(data.arrayBufs, 0, data.arrayBufs.length)]);
      //全覆盖...
      importDb(blob,(progress:any)=>{
        if (progress.completedRows == progress.totalRows){
          postMessage(EVENT_NOTE_CHANGED);//刷新card...
          postMessage(EVENT_REFRESH_LIBRARY_LIST);//或者list
          postMessage(EVENT_FAVIRIATE_CHANGE);//刷新收藏 ...
          window.refreshSyncMenu();//刷新时间...
          //转到列表
          // onRecentClick();
          resolve('ok');
        }
      }).then(res=>{
        postMessage(EVENT_NOTE_CHANGED);//刷新card...
        postMessage(EVENT_REFRESH_LIBRARY_LIST);//或者list
        postMessage(EVENT_FAVIRIATE_CHANGE);//刷新收藏 ...
        //转到列表
        // onRecentClick();
        resolve('ok');

        console.log(res);
      }).catch(e=>{
        console.log('importDB ERROR:',e);
      });
    })
  }

  const isWhiteDefaultBackground = ()=>{
    return window.location.href.includes('/card') || window.location.href.includes('/journal');
  }

  /**
   * 保存到云盘文件夹
   */
  const saveToCloud = ()=>{
    if (localStorage.getItem(KEY_IS_ENABLE_SYNC) == 'true' && localStorage.getItem(KEY_FILE_DIR) != global.g_defaultStorePath) {
      //sync
      ipcInvoke('check-cloud-time').then(async (data: any) => {
        if (data) {
          if (data.isPanNew) {//时间>或者=都刷新.
            // message.error(t('PanIsNewPleaseRefresh'));
            // 20260104给提示禁止保存到网盘
            window.showMessageBox(t('Tips'), t("LocalDataIsOld"), t("Cancel"), t("Confirm"), null, () => {
              window.backupDb();
              message.info(t('SyncProcessHasBeenInit'), 5);
            })
          } else {
            window.showMessageBox(t('Tips'), t("SaveToCloudTips"), t("Cancel"), t("Save"), null, () => {
              window.backupDb();
              message.info(t('SyncProcessHasBeenInit'), 5);
            })
          }
        } else {
          window.showMessageBox(t('Tips'), t("SaveToCloudTips"), t("Cancel"), t("Save"), null, () => {
            window.backupDb();
            message.info(t('SyncProcessHasBeenInit'), 5);
          })
        }
      });
    } else {
      message.info(t("PleaseEnableSync"));
      //打开设置
      window.showSettingDialog('sync');
    }
  }

  /**
   * 从云盘刷新
   */
  const refreshFromCloud = async ()=>{
    if (localStorage.getItem(KEY_IS_ENABLE_SYNC) == 'true' && localStorage.getItem(KEY_FILE_DIR) != global.g_defaultStorePath) {
      // window.showMessageBox(t('ConfirmRefresh'), t("AllLocalDataWillBeOverwrite"), t("Cancel"), t("Confirm"), null, () => {
      //
      // })

      //还原....
      autoRestore().then(res => {
        window.onProgressFinished(t("Refresh completed"));
        //不要保存首页的...
        global.g_isRestoreData = true;
        //回到首页
        //如果有首页，回到首页
        const szJson = localStorage.getItem(KEY_HOME_LEFT_MENU_CUSTOMIZE);
        let hasDefauleHome = false;
        if (szJson) {
          const jsonConfig = JSON.parse(szJson);
          hasDefauleHome = jsonConfig.home || false;
        }
        if (hasDefauleHome) {
          navDefaultProject(true);
        } else {
          onRecentClick();
        }
      }).catch(e => {
        window.closeProgress();
      })
    } else {
      message.info(t("PleaseEnableSync"));
      //打开设置
      window.showSettingDialog('sync');
    }
  }

  /**
   * logo下的菜单
   */
  const renderPopupLogoMenu = ()=>{
    return(
        <div className={'flex-col'} style={{minWidth: '240px', padding: '0 10px', fontSize: '12px'}}>
          <span className={'font-family-medium cursor-pointer'}
                style={{fontSize: '16px', marginTop: '6px', cursor: global.g_userInfo ? 'default' : 'pointer'}}
                onClick={() => {
                  setIsPopupMenuOpen(false);
                  if (!global.g_userInfo) {
                    ipcSend("open-url", import.meta.env.VITE_HTTP_REGISTER_URL);
                    if (DEBUG) {
                      dialogSetRef.current?.onShowLogin();
                    }
                  }
                }}>{loginAccount}</span>
          <span style={{color: 'var(--color-999)', marginTop: '6px'}}>{currentVersion}</span>
          <div className={'line'} style={{margin: '12px -22px 2px -22px'}}></div>

          <div className={style.homePopupMenuItem + ' flex-row-vertical-center hovered-blue hovered-filter-img'}
               onClick={() => {
                 setIsPopupMenuOpen(false);
                 dialogSetRef?.current?.onDialogShow();
               }}>
            <img className={'cursor-pointer img-16'}
                 src={getImagePathWithTheme("home_popup_menu_set")}/>
            <span>{t("Settings")}</span>
          </div>
          {/*<div className={style.homePopupMenuItem + ' flex-row-vertical-center hovered-blue hovered-filter-img'}*/}
          {/*     onClick={() => {*/}
          {/*       //导入....*/}
          {/*       setIsPopupMenuOpen(false);*/}
          {/*       fileInputRef.current?.click();*/}
          {/*     }}>*/}
          {/*  <img className={'cursor-pointer img-16'}*/}
          {/*       src={getImagePathWithTheme("home_popup_menu_import")}/>*/}
          {/*  <span>{t("Import")}</span>*/}
          {/*</div>*/}
          <div className={style.homePopupMenuItem + ' flex-row-vertical-center hovered-blue hovered-filter-img'}
               onClick={() => {
                 setIsPopupMenuOpen(false);
                 //回收站
                 navigate('/home/trash');
                 setSelectMenuItem('trash');
               }}>
            <img className={'cursor-pointer img-16'}
                 src={getImagePathWithTheme("home_popup_menu_trash")}/>
            <span>{t("Trash")}</span>
          </div>

          {
            false &&
            <>
              <div className={'line'} style={{margin: '1px -22px'}}></div>

              <div className={style.homePopupMenuItem + ' flex-row-vertical-center hovered-blue hovered-filter-img'}
                   onClick={() => {
                     //保存到网盘....
                     setIsPopupMenuOpen(false);

                     saveToCloud();
                   }}>
                <img className={'cursor-pointer img-16'}
                     src={getImagePathWithTheme("cloud_sync")}/>
                <span>{t("SaveToCloud")}</span>
              </div>
              <div className={style.homePopupMenuItem + ' flex-row-vertical-center hovered-blue hovered-filter-img'}
                   onClick={async () => {
                     //refresh----刷新...
                     setIsPopupMenuOpen(false);

                     refreshFromCloud();
                   }}>
                <img className={'cursor-pointer img-16'}
                     src={getImagePathWithTheme("cloud_refresh")}/>
                <span>{t("RefreshFromCloud")}</span>
              </div>
            </>
          }

        </div>
    )
  }

  const getHoverOrSelectColor = (p) => {
    if (p.isSelected) {
      return 'var(--select-background-color)'
    } else if (p.isHover) {
      return 'var(--hover-background-color)'
    }
    return 'transparent'
  }

  /**
   * 收藏的图片
   * @param item
   */
  const getFavorImage = (item) => {
    if (item.isFolder) {
      return 'tree_folder_collapse.svg'
    }
    if (item.type == 'card') {
      return 'favor_card.svg';
    } else if (item.type == 'tag') {
      return 'favor_tag.svg'
    } else if (item.type == 'journal') {
      return 'deeplink_journal'
    } else if (item.type == 'customFilter') {
      return 'favor_custom_filter.svg'
    }else if (item.type == 'linkFavor'){
      if (isDeepLink(item.url)){
        const deeplink = decodeDeeplink(item.url);
        let szImageName = 'menu_favor_link_no_same.svg';//getImageNameFromdeepLinkType(deeplink.elementType || deeplink.childType || deeplink.type);
        if (deeplink.type == 'library' || deeplink.type == 'highlight'){
          szImageName = getLibraryTypeImage(deeplink.elementType || deeplink.childType || deeplink.type);//getImageNameFromdeepLinkType(deeplink.elementType || deeplink.childType || deeplink.type);
        }else if (deeplink.type == 'project'){
          szImageName = 'favor_project.svg';
        }
        return szImageName;
      }else{
        return 'menu_favor_link_no_same.svg';
      }
    }
    return 'favor_project.svg'
  }

  /**
   * 转到默认的项目
   */
  const navDefaultProject = async (bToProjectList = false) => {
    //已经是首页的话不再响应
    if (mSelectMenuItem == 'home') {
      //转到项目列表
      if (bToProjectList) {
        onRecentClick();
      }
      return
    }
    ;

    const dbNote = await getNoteById(KEY_DEFAULT_PROJECT_ID);
    if (dbNote === null) {
      //new project
      navigate(getDrawPath(), {state: {folderId: '', projectId: KEY_DEFAULT_PROJECT_ID}});
    } else {
      navigate(getDrawPath(), {state: {noteData: dbNote}})
    }
    setTimeout(() => {
      setSelectMenuItem('home');
    }, 50)

    //最近置空
    resetFavorNoSelect();
    resetRecentNoSelect();
  }

  /**
   * 刷新收藏夹的最大高度....
   */
  const refreshFavorHeight = () => {

    const divTreeContainer = document.getElementById('div-tree-favor-list-shit-tree');
    if (divTreeContainer) {
      if (divTreeContainer.scrollHeight > divTreeContainer.clientHeight) {

      } else {

      }
    }

    if (isExpandFavor) {
      const homeConfig = localStorage.getItem(KEY_HOME_LEFT_MENU_CUSTOMIZE);
      let hasRecent = true
      if (homeConfig) {
        const jsonHomeConfig = JSON.parse(homeConfig);
        hasRecent = jsonHomeConfig.recent;
      }

      let nLength = 0;
      for (let i = 0; i < arrayFavirates.length; i++) {
        const item = arrayFavirates[i];
        if (item.isFolder) {
          nLength += 1;
          if (mExpandKeys.current.some(p => p.includes(item.id) || p == item.id)) {
            nLength += item.children.length;
          }
        } else {
          nLength += 1;
        }
      }


      if (!isExpandRecent || arrayRecents.length == 0 || !hasRecent) {
        //recent是折叠状态...
        //算一下最大可以允许的高度--
        const divFavorHeader = document.getElementById('div-favor-header');
        if (divFavorHeader) {
          let nTop = divFavorHeader.offsetTop;
          let nHeight = document.body.clientHeight - nTop - 38 - 50 - 50 - 18;//收藏38  最近50  底部栏 50  18不知道啥。。。
          if (arrayRecents.length == 0) {
            nHeight += 18;//加回来一个.
          }
          if (DEBUG || (showUpgrade && !hasAppUpdate)) {
            nHeight -= 100;
          } else {
            if (hasAppUpdate) {
              nHeight -= 60;
            }
          }

          if (!hasRecent) {
            //没有最近...
            nHeight += 40;
          }

          let nFavorHeight = nLength * 36;
          let nMaxHeight = nFavorHeight;
          if (nFavorHeight > nHeight) {
            nMaxHeight = nHeight;
            if (divTreeContainer) {
              divTreeContainer.style.overflowY = 'auto'
            }
          } else {
            if (divTreeContainer) {
              divTreeContainer.style.overflowY = 'hidden'
            }
          }
          // if (isShowUpgradeDialog){
          //   nMaxHeight -= 60;
          // }
          if (!isFavorHover){
            if (divTreeContainer){
              divTreeContainer.style.overflowY = 'hidden'
            }
          }
          return nMaxHeight+'px';
        }
        return (nLength)*36 + 'px';
      }else{
        //1036对应6个。
        if (divTreeContainer){
          if (nLength >= 6){
            divTreeContainer.style.overflowY = 'auto'
          }else{
            divTreeContainer.style.overflowY = 'hidden'
          }

          if (!isFavorHover){
            divTreeContainer.style.overflowY = 'hidden'
          }
        }

        return (nLength >= 6?6:(nLength))*36+'px'
      }
    }

    return 'auto';
    // isExpandFavor?(arrayFavirates.length >= 7?7:(arrayFavirates.length+1))*36+'px':'auto'
  }

  /**
   * 使用了全动态的key--这里要刷新已经打开的key
   */
  const refreshExpandKeys = (expandedKeys,expanded)=>{
    // console.log('refreshexpand:');
    const arrayNewExpandKeys = [];
    for (let i=0;i<mArrayFavs.length;i++){
      const item = mArrayFavs[i];
      const bExist = expandedKeys.some(p=>p.includes(item.id));
      if (bExist){
        arrayNewExpandKeys.push(item.key);
      }
    }
    //2个集合都算。。。KEY也不知道什么会改。这个控件有点CD
    for (let i=0;i<arrayFavirates.length;i++){
      const item = arrayFavirates[i];
      const bExist = expandedKeys.some(p=>p.includes(item.id));
      if (bExist){
        if (!arrayNewExpandKeys.includes(item.key)){
          arrayNewExpandKeys.push(item.key);
        }
      }
    }
    if (expanded?.expanded == false){
      const nIndex = arrayNewExpandKeys.findIndex(p=>p.includes(expanded.node.id));
      if (nIndex != -1){
        arrayNewExpandKeys.splice(nIndex,1);
      }
    }

    mExpandKeys.current = arrayNewExpandKeys;
    setExpandKeys(mExpandKeys.current);
  }

  const onExpand:TreeProps["onExpand"]=((expandedKeys:any, expanded) => {
    console.log('onExpand');
    mIsInExpandClicked.current = true;
    //有时候点击不会到这里。为什么？？？？？有时候点击不会到这里。为什么？？？？？有时候点击不会到这里。为什么？？？？？有时候点击不会到这里。为什么？？？？？有时候点击不会到这里。为什么？？？？？有时候点击不会到这里。为什么？？？？？
    if (mFavorEditableId.current)return;
    if (!expanded.node.isFolder)return;
    if (mIsDragging.current)return;

    const newNode = arrayFavirates.find(p=>p.id == expanded.node.id);
    if (newNode){
      if (!newNode.isFolder || newNode.isEditable)return;
    }
    //找前面id相同的，就是expandedKeys
    refreshExpandKeys(expandedKeys,expanded);
    // mExpandKeys.current = expandedKeys;
    // setExpandKeys(expandedKeys);
  })

  const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {
    console.log('onselect',mIsInExpandClicked.current);
    if (info.node.isFolder){
      if (!mIsInExpandClicked.current){
        console.log('onselect');
        //这里是点击没有进入onExpand??????
        //判断一下这个selectedKey
        if (selectedKeys.length > 0){
          const arrayExpands = [...expandKeys];
          const nIndex = arrayExpands.findIndex(p=>p == selectedKeys[0]);
          if (nIndex != -1){
            //删除这个
            arrayExpands.splice(nIndex,1);
          }else{
            arrayExpands.push(selectedKeys[0]);
          }
          mExpandKeys.current = arrayExpands;
          setExpandKeys(arrayExpands);
        }
      }
      mIsInExpandClicked.current = false;
      return;
    };


    if (mIsClickedHandle){
      mIsClickedHandle = false;
      return;
    }

    //增加判断，如果画布那边正在加载，不要响应.等加载完了，再响应...
    if (window.isLoadingProject){
      if (window.isLoadingProject()) {
        console.log('****************************************************isLoadingProject*************');
        return
      }
    }


    const isNavItem = await navFavor(info.node);
    if (isNavItem) {
      //选中当前项目
      var arrayNew = [...arrayFavirates];
      arrayNew.forEach(p => p.isSelected = false);
      // item.isSelected = true;//收藏夹的永远不选中
      setArrayFavirates(arrayNew);

      setSelectMenuItem('')

      //将recent全部置为未选中
      resetRecentNoSelect();
    }
  })

  const loopRemove = (data, key) => {
    for (var i = 0; i < data.length; i++) {
      var item = data[i];
      if (item.isFolder) {
        for (var j = 0; j < item.children.length; j++) {
          var subItem = item.children[j];
          if (subItem.key === key) {
            item.children.splice(j, 1);
            return subItem;
          }
        }
      } else {
        if (item.key === key) {
          data.splice(i, 1);
          return item;
        }
      }
    }
  }

  const onDragStart = (info)=>{
    console.log('onDragStart');
    mIsDragging.current = true;
  }

  const onDragOver = (info)=>{
    mIsDefaultDragOk = false;

    if (mRootDiv != null) {
      mRootDiv.style.border = '0px';
    }
    mSelectFolder = null;

    if (info.node.isFolder) {
      mRootDiv = info.event.currentTarget;
      mRootDiv.style.border = '1px solid #0085FF';
      mRootDiv.style.borderRadius = '4px'
      mSelectFolder = mRootDiv;
    } else {
      //根据ID找到父级
      loop(arrayFavirates, info.node.key, ((node, i, data, parent) => {
        if (parent != undefined) {
          var div = document.getElementById(parent.key);
          if (div != undefined) {
            mRootDiv = div.parentElement.parentElement.parentElement;
            mRootDiv.style.border = '1px solid #0085FF';
            mRootDiv.style.borderRadius = '4px'
          }
        }
      }))
    }
  }

  const onDragEnd = (info)=>{
    mIsDragging.current = false;
    if (mRootDiv != null) {
      mRootDiv.style.border = '0px';
    }
    if (mSelectFolder != null && !mIsDefaultDragOk) {
      let szMoveKey = info.node.key;
      if (info.dragNode != undefined) {
        szMoveKey = info.dragNode.key;
      }
      var arrayDivs = mSelectFolder.getElementsByClassName("custom-tree-node");
      if (arrayDivs.length > 0) {
        setTimeout(() => {
          var szDestId = arrayDivs[0].id;
          var arrayNew = [...arrayFavirates];
          for (var i = 0; i < arrayNew.length; i++) {
            var item = arrayNew[i];
            if (item.id === szDestId && item.isFolder) {
              //移动到的父级....
              //从原来的里面删除
              var newNode = loopRemove(arrayNew, szMoveKey);
              if (newNode){
                item.children.splice(0,0,newNode);
                setArrayFavirates(arrayNew);
                //更新到数据库
                updateFavorFolder(item);
              }
              break;
            }
          }
        }, 50);
      }
    }
  }

  const onDrop: TreeProps['onDrop'] = (info) => {
    // console.log(info);
    mIsDragging.current = false;

    if (mRootDiv != null) {
      mRootDiv.style.border = '0px';
    }
    var isDragOk = true;
    const dropKey = info.node.key;
    const dragKey = info.dragNode.key;
    const dropPos = info.node.pos.split('-');
    const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
    const data = [...arrayFavirates];

    // Find dragObject
    let dragObj: DataNode;
    loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });

    mIsDefaultDragOk = false;


    if (!info.dropToGap) {
      // Drop on the content
      let nFolderPosition = -1;
      loop(data, dropKey, (item) => {
        if (item.children == null) {//不能移到画布下一级。。。。
          //插入到当前下...
          for (let i=0;i<data.length;i++){
            const favor = data[i];
            if (favor.isFolder){
              const nCurIndex = favor.children.findIndex(p=>p.id == item.id);
              if (nCurIndex != -1){
                //插入到这个位置
                favor.children.splice(nCurIndex+1, 0, info.dragNode);
                isDragOk = true;
                break;
              }
            }
          }
        } else {
          if (info.dragNode.isFolder && item.isFolder) {
            isDragOk = true;
            //添加到和item平级的下面一个位置.
            nFolderPosition = data.findIndex(p=>p.key == item.key);
          } else {
            item.children = item.children || [];
            // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
            item.children.unshift(dragObj);
          }
        }
      });
      if (nFolderPosition != -1){
        //添加到和item平级的下面一个位置.
        data.splice(nFolderPosition+1,0,info.dragNode);
      }
      mIsDefaultDragOk = true;
    } else if (
        ((info.node as any).props.children || []).length > 0 && // Has children
        (info.node as any).props.expanded && // Is expanded
        dropPosition === 1 // On the bottom gap
    ) {
      loop(data, dropKey, (item) => {
        if (item.children == null) {//不能移到画布下。。。。
          isDragOk = false;
        } else {
          if (info.dragNode.isFolder && item.isFolder) {
            isDragOk = false;
          } else {
            item.children = item.children || [];
            // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
            item.children.unshift(dragObj);
            // in previous version, we use item.children.push(dragObj) to insert the
            // item to the tail of the children
          }
        }
      });
    } else {
      let ar: DataNode[] = [];
      let i: number = 0;
      loop(data, dropKey, (_item, index, arr, parent) => {
        if ((info.dragNode.isFolder && (_item.isFolder || parent?.isFolder))) {
          isDragOk = true;
          //移动位置....
          ar = arr;
          i = index;
        } else {
          ar = arr;
          i = index;
        }
      });
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }
    }

    if (isDragOk) {
      for (let i = 0; i < data.length; i++) {
        data[i].sort = i;
      }
      setArrayFavirates(data);

      //更新回文件夹...
      //重新保存
      for (let i = 0; i < data.length; i++) {
        const item = {...data[i], sort: i}
        if (item.isFolder){
          updateFavorFolder(item)
        }else{
          //不同类型的更新。
          if (item.type == 'card') {
            updateCard(item);
          } else if (item.type == 'tag') {
            updateTag(item);
          } else {
            updateNote(item);
          }
        }
      }
    }

    if (arrayFavirates.length != data.length) {
      mIsDefaultDragOk = true;
    }
  }

  // 找到节点数据并回调处理节点方法 callback回调: node-当前节点 i-当前节点序号 data-包含当前节点的节点组 parentNode 当前节点父节点
  const loop = (
      data: any[],
      key: React.Key,
      callback: (node: any, i: number, data: any[], parent?: any) => void,
      parentNode?: any,
  ) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].key === key) {
        return callback(data[i], i, data, parentNode);
      }
      if (data[i].children) {
        loop(data[i].children!, key, callback, data[i]);
      }
    }
  };

  /**
   * 当更新了收藏-RENAME 等需要刷新的地方。。
   */
  const onNeedRefreshFavorAAAAAAA = ()=>{
    postMessage(EVENT_NOTE_CHANGED);
    postMessage(EVENT_REFRESH_LIBRARY_LIST);
    postMessage(EVENT_REFRESH_TAG_LSIT);
    //N个可能的地方需要刷新，各种界面.!
    postMessage(EVENT_REFRESH_DRAW_FAVOR);
  }

  const onDropFile = (event:any)=>{
    if (isInPageLibrary()){
      const szImportMode = localStorage.getItem(KEY_FILE_IMPORT_MODE) || IMPORT_FILE_MODE_IMPORTMODE;
      const files = event.dataTransfer.files;
      if (files.length > 0){
        if (szImportMode == IMPORT_FILE_MODE_ASKME){
          window.showDialogFileImportDrag((szAction)=>{
            onImportFileToLibrary(szAction,files)
          })
        }else{
          onImportFileToLibrary(szImportMode,files)
        }
      }
    }
  }

  /**
   * 导入
   * @param szImportMode
   * @param files
   */
  const onImportFileToLibrary = async (szImportMode:any,files:any)=>{
    window.showProgress();
    let libraryItem:any = null;
    for (let i=0;i<files.length;i++){
      const file = files[i];
      await copyOneFile(file,szImportMode,(library:any)=>{
        libraryItem = library;
      });
    }
    //显示
    window.onShowMessageTip(t("Import complete"),()=>{
      //转到library
      window.showLibraryFilePreview(libraryItem);
    })
  }

  /**
   * 右侧栏部分的高度---
   */
  const getRightPartHeight = ()=>{
    return '100%';
    // if (isMac() || isInDraw()){
    //   return '100%';
    // }
    // return 'calc(100vh - ' + '0px)'
    // isMac()?'100vh':'calc(100vh - ' + '0px)'
  }

  return (
      <div className={'default-font-family no-select'} style={{display: 'flex', flexDirection: 'column'}}>

        {
            !isMac() &&
            <TitleBar title={t("Home")} isDark={false} fromPage={'home'}></TitleBar>
        }
        {
            isMac() &&
            <div className={isMac() ? 'drag' : 'windows-no-drag'} style={{
              position: 'fixed',
              left: '0',
              top: '0',
              height: '46px',
            width: '100%',
            background: 'red',
            zIndex: '-1',
            opacity: '0'
          }}></div>
        }

        {/*//logo*/}
        <Tooltip title={t("AppName")} arrow={false} placement={'bottom'}>
          <Popover arrow={false} onVisibleChange={()=>{
            if (global.g_userInfo) {
              setLoginAccount(global.g_userInfo.username + "(" + global.g_userInfo.email + ")")
            }else {
              setLoginAccount(t("Login"))
            }
          }} trigger={['click']} open={isPopupMenuOpen} onOpenChange={(e)=>setIsPopupMenuOpen(e)} content={renderPopupLogoMenu()} align={{offset:[36,2]}}>
            <div className={'cursor-pointer hovered-gray-radius'} style={{
              display: (homePaddingLeft==0 )?'none':'flex',
              alignItems: 'center',
              marginTop:'-3px',
              padding: '4px 12px 4px 12px',
              position:'fixed',
              top:isOfflineWeb()?'11px':(isMac()?(isFullScreen?'11px':'64px'):'40px'),
              left:'10px',
              zIndex:'11',
              marginBottom: isMac()?'16px':'26px'
            }} onClick={() => {
              // message.info('testing....');
              // updateDeleteOrFavor();
            }}>
              <img style={{width: '74px', height: '22px', marginLeft: '0px'}} src={getImagePathWithTheme('home_logo')}/>
              {/*<span style={{marginLeft:'8px',fontSize:'16px',fontWeight:'500'}}>{t("AppName")}</span>*/}
              <div className={'flex-column-center ml-4'}>
                <img className={'img-10'}
                     src={getImagePathWithTheme('home_small_up.svg')}/>
                <img className={'img-10'} style={{marginTop: '-2px'}}
                     src={getImagePathWithTheme('home_small_down.svg')}/>
              </div>
              {/*<img style={{width:'84px',height:'18px',marginLeft:'4px'}} src={imgPathPerfix()+"muenzo.png"}/>*/}
            </div>
          </Popover>
        </Tooltip>


        <div className={style.home}
             style={{
               paddingLeft: `${homePaddingLeft}px`,
               // height: isMac() ? '100vh' : `calc(100vh - ${TITLE_BAR_HEIGHT}px)`,//windows frame预览时底下会有TITLE_BAR_HEIGHT空白
               height:'100vh',
               marginTop: isMac() ? '0' : `${0}px`
             }}>
          <div id={'div-home-left-part'} className={style.left} style={{
            borderRight: isPresentMode?'none':(selectMenuItem == 'recent' ? '1px solid var(--home-left-border-color)' : '1px solid var(--home-left-border-color)'),
            top: (isWeb() || isMac()) ? '0px' : '6px',
            height: isWeb() ? '100%' : 'calc(100% - 0px)',
            width: `${homePaddingLeft}px`,
            padding: (homePaddingLeft == 0) ? '0' : '0 6px',
            overflow: 'hidden',
            paddingBottom: '0px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginTop: isMac() ? '6px' : '30px'
            }}>
              {/*<Tooltip title={t("Settings")}>*/}
              {/*  <img className={'cursor-pointer hovered-gray-radius'} style={{width: '32px', height: '32px'}}*/}
              {/*       src={getImagePathWithTheme("home_setting")} onClick={() => {*/}
              {/*    dialogSetRef?.current?.onDialogShow();*/}
              {/*  }}/>*/}
              {/*</Tooltip>*/}

              <Tooltip overlayClassName='font-size-12' title={
                <div>{t("Sidebar")}<span className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + /")}</span></div>}
                       arrow={true}>
                <img className={'cursor-pointer ml-6 mr-2 hovered-gray-radius'}
                     style={{width: '32px', height: '32px', marginRight: '2px', marginTop: '1px'}}
                     src={getImagePathWithTheme("home_left_slider.svg")} onClick={() => {
                  setHomePaddingLeft(homePaddingLeft == 0 ? HOME_LEFT_MENU_WIDTH : 0)
                }}/>
              </Tooltip>
            </div>

            <div style={{
              flexShrink: '0',
              height: isOfflineWeb() ? '14px' : (isMac() ? (isFullScreen ? '10px' : '56px') : '16px')
            }}></div>

            {/*-new content-*/}
            <div className={'flex-row-vertical-center default-font-size cursor-pointer font-family-regular'}
                 style={{width: '100%', margin: '8px 0'}}>
              <Tooltip title={t('New content')} arrow={false}>
                <Dropdown trigger={['click']} placement={'bottomCenter'} align={{offset: [186, -30]}}
                          menu={{items: ARRAY_NEW_CONTENT_MENU}}>
                  <div className={'flex-center hovered-gray-radius'} style={{
                    borderRadius: '8px',
                    border: '1px solid var(--search-border-color)',
                    flexGrow: '1',
                    padding: '0px 18px',
                    height: '36px',
                    background:'var(--home-global-search-icon-backgroundcolor)'
                  }}>
                    <img className={'img-14'} src={getImagePathWithTheme('home_new_content.svg')}/>
                    <span className={'ml-8'}>{t("New content")}</span>
                  </div>
                </Dropdown>
              </Tooltip>

              <Tooltip overlayClassName={'font-size-12'} arrow={false} title={<div
                  className={'default-font-size'}>{t("GlobalSearch")}<span
                  className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + K")}</span></div>}>
                <div className={'flex-center cursor-pointer hovered-gray-radius'} style={{
                  width: '36px',
                  height: '36px',
                  border: '1px solid var(--search-border-color)',
                  borderRadius: '8px',
                  flexShrink: '0',
                  background:'var(--home-global-search-icon-backgroundcolor)',
                  marginLeft: '8px'
                }} onClick={() => {
                  if (window.saveNotes) {
                    window.saveNotes();
                  }
                  window.showDialogGlobalSearch();
                }}>
                  <img className={'img-18'} src={getImagePathWithTheme('home_global_search.svg')}/>
                </div>
              </Tooltip>

            </div>

            {/*//home*/}
            {
                homeLeftMenu?.home &&
                <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                  <div id={'div-home-item'} className={style.folderItemFolderHeader} onClick={() => {
                    //转到默认的项目
                    navDefaultProject();
                  }} style={{
                    backgroundColor: selectMenuItem == 'home' ? 'var(--select-background-color)' : 'transparent',
                    paddingLeft: '18px'
                  }}>
                    <img className='menu-icon-size'
                         src={selectMenuItem == 'home' ? getImagePathWithThemeSvg("home_project_home_pressed") : getImagePathWithThemeSvg("home_project_home_normal")}/>
                    <span className='theme-text-color ml-8'
                          style={{
                            color: selectMenuItem == 'home' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                            fontWeight: selectMenuItem == 'home' ? '600' : 'normal'
                          }}>{t("Home")}</span>
                  </div>
                </div>
            }


            {/*//recent*/}
            {
              <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                <div className={style.folderItemFolderHeader} onClick={onRecentClick} style={{
                  backgroundColor: selectMenuItem == 'recent' ? 'var(--select-background-color)' : 'transparent',
                  paddingLeft: '18px'
                }}>
                  <img className='menu-icon-size'
                       src={selectMenuItem == 'recent' ? getImagePathWithThemeSvg("home_project_pressed") : getImagePathWithThemeSvg("home_project_normal")}/>
                  <span className='theme-text-color ml-8'
                        style={{
                          color: selectMenuItem == 'recent' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                          fontWeight: selectMenuItem == 'recent' ? '600' : 'normal'
                        }}>{t("Projects")}</span>
                </div>
              </div>
            }


            {/*//journal*/}
            {
                homeLeftMenu?.journal &&
                <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                  <div className={style.folderItemFolderHeader} onClick={() => {
                    navPage('journal')
                  }} style={{
                    backgroundColor: selectMenuItem == 'journal' ? 'var(--select-background-color)' : 'transparent',
                    paddingLeft: '18px'
                  }}>
                    <img className='menu-icon-size'
                         src={selectMenuItem == 'journal' ? getImagePathWithThemeSvg("home_journal_pressed") : getImagePathWithThemeSvg("home_journal")}/>
                    <span className='theme-text-color ml-8'
                          style={{
                            color: selectMenuItem == 'journal' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                            fontWeight: selectMenuItem == 'journal' ? '600' : 'normal'
                          }}>{t("Journal")}</span>
                  </div>
                </div>
            }


            {/*//template*/}
            {/*<div className='folderItemFolderHeader flex-row-vertical-center hovered  border-radius-8 overflow-hidden' onClick={()=>dialogTemplateRef?.current?.onShowDialog()}>*/}
            {/*  <img className='img-medium-small' src={imgPathPerfix()+"template.png"}/>*/}
            {/*  <span className='ml-8' style={{flexGrow:'1'}}>{t("Templates")}</span>*/}
            {/*</div>*/}

            {/*//文件夹*/}
            {
                false &&
                <div className={'mt-4'}>
                  <div className='hovered border-radius-8 overflow-hidden' onMouseEnter={(e) => {
                    setIsMoveLeftPartFolder(true);
                  }} onMouseLeave={(e) => {
                    setIsMoveLeftPartFolder(false);
                  }}>
                    <div className={style.folderItemFolderHeader}
                         style={{backgroundColor: selectMenuItem == 'folder' ? 'var(--select-background-color)' : 'transparent'}}
                         onClick={() => onNavFolderClick()}>
                      <img className='img-medium-small'
                           src={(selectMenuItem == 'folder' ? getImagePathWithTheme("left_folder_selected") : getImagePathWithTheme("left_folder"))}/>
                      <span style={{flexGrow: '1', marginLeft: '9px'}}>{t("Folders")}</span>

                      {
                          isMoveLeftPartFolder &&
                          <img className='img-mini-small-12' src={getImagePathWithTheme('home_dropdown')}
                               style={{
                                 transform: isExpand ? 'rotate(180deg)' : 'rotate(0deg)',
                                 width: '12px',
                                 height: '7px'
                               }}
                               onClick={() => onCollapseOrExpand()} rotate={isExpand ? 0 : 180}/>
                      }

                    </div>
                  </div>

                  <div style={{
                    overflowY: "auto",
                    overflowX: 'hidden',
                    display: isExpand ? 'inherit' : 'none',
                    maxHeight: '360px'
                  }} className='ul-item'>
                    <List
                        split={false}
                        itemLayout="horizontal"
                        dataSource={arrayFolders}
                        renderItem={(item, index) => (
                            <List.Item data-index={index} onClick={onFolderItemClick}
                                       onContextMenu={(e) => onFolderItemClick(e)} onMouseEnter={onFolderItemEnter}
                                       onMouseLeave={onFolderItemLeave}>
                              <Dropdown overlayClassName='default-dropdown-style' menu={{items: itemsMore}}
                                        trigger={['contextMenu']}>
                                <div className={style.folderItemListItem} style={{marginLeft: '-12px', height: '28px'}}>
                                  <div style={{
                                    display: 'flex',
                                    width: 'calc(100% + 32px)',
                                    alignItems: 'center',
                                    marginLeft: '-16px',
                                    paddingLeft: '16px',
                                    height: '28px',
                                    lineHeight: '28px',
                                    marginRight: '-16px',
                                    backgroundColor: item.isSelect ? 'var(--select-background-color)' : 'transparent'
                                  }}>
                                    <div style={{marginLeft: '22px', alignItems: 'center', display: 'flex'}}>
                                      {item.id === '-1' ?
                                          <img className='img-medium-small'
                                               src={getImagePathWithTheme('create_folder')}/> :
                                          <img className='img-medium-small'
                                               src={getImagePathWithTheme('left_folder_1')}/>}
                                    </div>

                                    <input readOnly={true} type={"text"} style={{
                                      color: item.id === '-1' ? '#888888' : 'var(--text-color)',
                                      flexGrow: '1',
                                      marginLeft: '6px',
                                      fontSize: '12px',
                                      height: '28px',
                                      lineHeight: '28px',
                                    }} className={'default-font-size ' + style.folderItemInput}
                                           value={item.name}></input>
                                    {/*<Dropdown menu={{items: itemsMore}} trigger={['click']}>*/}
                                    {/*  <MoreOutlined style={{flexShrink:'0',visibility:item.showMore?'visible':'hidden',margin:'0 12px'}}/>*/}
                                    {/*</Dropdown>*/}
                                  </div>
                                </div>
                              </Dropdown>
                            </List.Item>
                        )}
                    />
                  </div>
                </div>
            }


            {/*//library*/}
            {
              <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                <div className={style.folderItemFolderHeader} onClick={() => {
                  navPage('library');
                }} style={{
                  backgroundColor: selectMenuItem == 'library' ? 'var(--select-background-color)' : 'transparent',
                  paddingLeft: '18px'
                }}>
                  <img className='menu-icon-size'
                       src={selectMenuItem == 'library' ? getImagePathWithThemeSvg("home_library") : getImagePathWithThemeSvg("home_library_normal")}/>
                  <span className='theme-text-color ml-8'
                        style={{
                          color: selectMenuItem == 'library' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                          fontWeight: selectMenuItem == 'library' ? '600' : 'normal'
                        }}>{t("Library")}</span>
                </div>
              </div>
            }


            {/*//tags*/}
            {
                homeLeftMenu?.tags &&
                <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                  <div className={style.folderItemFolderHeader} onClick={() => {
                    navPage('tags');
                  }} style={{
                    backgroundColor: selectMenuItem == 'tags' ? 'var(--select-background-color)' : 'transparent',
                    paddingLeft: '16px'
                  }}>
                    <img style={{marginLeft: '2px'}} className='menu-icon-size'
                         src={selectMenuItem == 'tags' ? getImagePathWithThemeSvg("home_tags_pressed") : getImagePathWithThemeSvg("home_tags_normal")}/>
                    <span className='theme-text-color ml-8'
                          style={{
                            color: selectMenuItem == 'tags' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                            fontWeight: selectMenuItem == 'tags' ? '600' : 'normal'
                          }}>{t("Tags")}</span>
                  </div>
                </div>
            }


            {/*//Highlight*/}
            {
                homeLeftMenu?.highlights &&
                <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                  <div className={style.folderItemFolderHeader} onClick={() => {
                    navPage('highlight');
                  }} style={{
                    backgroundColor: selectMenuItem == 'highlight' ? 'var(--select-background-color)' : 'transparent',
                    paddingLeft: '18px'
                  }}>
                    <img className='menu-icon-size'
                         src={selectMenuItem == 'highlight' ? getImagePathWithThemeSvg("home_highlight_pressed") : getImagePathWithThemeSvg("home_highlight")}/>
                    <span className='theme-text-color ml-8'
                          style={{
                            color: selectMenuItem == 'highlight' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                            fontWeight: selectMenuItem == 'highlight' ? '600' : 'normal'
                          }}>{t("Highlights")}</span>
                  </div>
                </div>
            }


            {/*//inbox*/}
            {
                false &&
                <div className='hovered border-radius-8 overflow-hidden'>
                  <div className={style.folderItemFolderHeader} onClick={() => {
                    setSelectMenuItem('inbox');
                    navigate("/home/inbox");
                  }} style={{
                    backgroundColor: selectMenuItem == 'inbox' ? 'var(--select-background-color)' : 'transparent',
                    paddingLeft: '18px'
                  }}>
                    <img className='img-14'
                         src={selectMenuItem == 'inbox' ? getImagePathWithTheme("home_inbox_pressed") : getImagePathWithTheme("home_inbox_normal")}/>
                    <span className='theme-text-color ml-8 font-weight-500'
                          style={{color: selectMenuItem == 'inbox' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)'}}>{t("Inbox")}</span>
                  </div>
                </div>
            }

            {/*//tasks*/}
            {
                // <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                //   <div className={style.folderItemFolderHeader} onClick={() => {
                //     navPage('task')
                //   }} style={{
                //     backgroundColor: selectMenuItem == 'task' ? 'var(--select-background-color)' : 'transparent',
                //     paddingLeft: '18px'
                //   }}>
                //     <img className='img-14'
                //          src={selectMenuItem == 'task' ? getImagePathWithThemeSvg("home_tasks_pressed") : getImagePathWithThemeSvg("home_tasks")}/>
                //     <span className='theme-text-color ml-8'
                //           style={{
                //             color: selectMenuItem == 'task' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                //             fontWeight: selectMenuItem == 'task' ? '600' : 'normal'
                //           }}>{t("Tasks")}</span>
                //   </div>
                // </div>
            }

            {/*//property*/}
            {
                homeLeftMenu?.properties &&
                <div className='hovered border-radius-8 overflow-hidden no-shrink'>
                  <div className={style.folderItemFolderHeader} onClick={() => {
                    navPage('property');
                  }} style={{
                    backgroundColor: selectMenuItem == 'property' ? 'var(--select-background-color)' : 'transparent',
                    paddingLeft: '16px'
                  }}>
                    <img style={{marginLeft: '2px'}} className='menu-icon-size'
                         src={selectMenuItem == 'property' ? getImagePathWithThemeSvg("home_property_pressed") : getImagePathWithThemeSvg("home_property_normal")}/>
                    <span className='theme-text-color ml-8'
                          style={{
                            color: selectMenuItem == 'property' ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                            fontWeight: selectMenuItem == 'property' ? '600' : 'normal'
                          }}>{t("Properties")}</span>
                  </div>
                </div>
            }



            {/*//收藏*/}
            {
              //region 收藏--
                homeLeftMenu?.favor && arrayFavirates.length > 0 &&
                <div style={{
                  marginTop: '16px',
                  overflow: 'hidden',
                  flexShrink: '0',
                  height: 'auto'
                }}>
                  <div
                      id={'div-favor-header'}
                      className='folderItemFolderHeader flex-row-vertical-center hovered border-radius-8 overflow-hidden'
                      onClick={() => {
                        onCollapseOrExpandFavor()
                      }} onMouseEnter={(e) => {
                    setIsMoveLeftPartFavor(true);
                  }} onMouseLeave={(e) => {
                    setIsMoveLeftPartFavor(false);
                  }} style={{background: 'transparent', cursor: 'pointer'}}>
                    {/*<img className='img-medium-small' src={getImagePathWithTheme("favor")}/>*/}
                    <div className={'flex-row-vertical-center'}>
                      <img className='img-16' style={{
                        marginLeft: '0px',
                        transform: isExpandFavor ? 'rotate(0deg)' : 'rotate(-90deg)',
                        visibility: isMoveLeftPartFavor ? 'visible' : 'visible'
                      }} src={getImagePathWithTheme("home_small_favor_dropdown.svg")}/>
                      <span className='ml-6 theme-text-color'
                            style={{flexGrow: '1', color: 'var(--home-favor-text-color)'}}>{t("favor").toUpperCase()}</span>
                    </div>

                    {/*new favor folder  新建收藏文件夹 新建文件夹     */}
                    <Dropdown menu={{
                      items: itemFavor(), onClick: (item: any) => {

                      }
                    }} trigger={['click']}>
                      <Tooltip arrow={false} title={t("NewLinkAndFolder")}>
                        <img style={{marginLeft: 'auto', marginRight: '-8px'}} className={'img-14'}
                             src={getImagePathWithTheme('add_black', true)} onClick={(event) => {
                          event.stopPropagation();

                        }}/>
                      </Tooltip>
                    </Dropdown>

                    {
                      // isMoveLeftPartFavor && false &&
                      // <img className='img-mini-small-12' src={getImagePathWithTheme('home_dropdown')}
                      //      style={{
                      //        transform: isExpandFavor ? 'rotate(180deg)' : 'rotate(0deg)',
                      //        marginRight: '0px',
                      //        width: '12px',
                      //        height: '7px'
                      //      }}
                      //      onClick={(event) => {
                      //        // onCollapseOrExpandFavor();
                      //        event.stopPropagation();
                      //        event.preventDefault();
                      //      }} rotate={isExpandFavor ? 0 : 180}/>
                    }

                  </div>

                  {
                    //region 旧的先隐藏....
                      false &&
                      <div style={{
                        overflow: isFavorHover ? 'auto' : 'hidden',
                        display: isExpandFavor ? 'inherit' : 'none',
                        // height:isExpandFavor?((arrayFavirates.length >= 7?7:(arrayFavirates.length+1))*36 - 36)+'px':'auto'
                        height: refreshFavorHeight()
                      }} onMouseEnter={(event) => {
                        setIsFavorHover(true)
                      }} onMouseLeave={() => {
                        setIsFavorHover(false)
                      }}>
                        <DragDropContext onDragEnd={(result) => {
                          if (!result.destination) return;
                          const newItems = Array.from(arrayFavirates);
                          const item = newItems.splice(result.source.index, 1)[0];
                          newItems.splice(result.destination.index, 0, item);
                          setArrayFavirates(newItems);

                          //重新保存
                          for (let i = 0; i < newItems.length; i++) {
                            const item = {...newItems[i], sort: i}
                            //不同类型的更新。
                            if (item.type == 'card') {
                              updateCard(item);
                            } else if (item.type == 'tag') {
                              updateTag(item);
                            } else {
                              updateNote(item);
                            }
                          }
                        }}>
                          <Droppable droppableId={'droppable'}>
                            {
                              (provided: any) => (
                                  <ul className='ul-item'
                                      style={{overflow: isFavorHover ? 'auto' : 'hidden', height: '100%'}}
                                      ref={provided.innerRef} {...provided.droppableProps}>
                                    {
                                      arrayFavirates.map((item, i) =>
                                          <Draggable key={item.id} draggableId={item.id + ''} index={i}>
                                            {
                                              (provided) => (
                                                  <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                  >
                                                    <Dropdown key={item.id} overlayClassName='default-dropdown-style'
                                                              menu={{items: ARRAY_FAVOR_MENU(), onClick: handleMenuClick}}
                                                              trigger={['contextMenu']}>
                                                      <li data-id={item.id} style={{
                                                        paddingLeft: '16px',
                                                        height: '36px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        paddingRight: '12px',
                                                        borderRadius: '8px',
                                                        color: 'var(--home-left-normal-item-color)',
                                                        background: (item.isHover || item.isSelected) ? 'var(--hover-background-color)' : 'transparent'
                                                      }} key={i}
                                                          onMouseEnter={() => {
                                                            var arrayNew: any = [...arrayFavirates];
                                                            arrayNew.forEach(p => p.isHover = false);
                                                            item.isHover = true;
                                                            item.isOpen = false;
                                                            setArrayFavirates(arrayNew);
                                                          }}
                                                          onMouseLeave={() => {
                                                            var arrayNew: any = [...arrayFavirates];
                                                            // item.isHover = false;
                                                            arrayNew.forEach(p => {
                                                              p.isHover = false;
                                                              p.isOpen = false;
                                                            });
                                                            setArrayFavirates(arrayNew);
                                                          }}
                                                          onContextMenu={(e) => {
                                                            mCurrentFavorNote = item;
                                                            // const szId = e.currentTarget.dataset.id;
                                                            // getNoteById(szId as string).then(res => {
                                                            //   mCurrentFavorNote = res;
                                                            // })
                                                          }} onClick={async (event) => {
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        if (event.target.localName == 'img'
                                                            || event.target.className == "ant-dropdown-menu-title-content"
                                                            || event.target.className == "anticon"
                                                            || event.target.className == 'ant-dropdown-menu-item ant-dropdown-menu-item-active') return;

                                                        const isNavItem = await navFavor(item);
                                                        if (isNavItem) {
                                                          //选中当前项目
                                                          var arrayNew = [...arrayFavirates];
                                                          arrayNew.forEach(p => p.isSelected = false);
                                                          // item.isSelected = true;//收藏夹的永远不选中
                                                          setArrayFavirates(arrayNew);

                                                          setSelectMenuItem('')

                                                          //将recent全部置为未选中
                                                          resetRecentNoSelect();
                                                        }
                                                      }}>
                                                        <img className='img-14'
                                                             src={getImagePathWithTheme(getFavorImage(item))}/>
                                                        <span className='ml-6 span-single-line'
                                                              style={{
                                                                marginLeft: '8px',
                                                                flexGrow: '1',
                                                                marginTop: '1px'
                                                              }}>{getCardTitle(item)}</span>
                                                        {
                                                            item.isHover &&
                                                            <Dropdown open={item.isOpen} menu={{
                                                              items: ARRAY_FAVOR_MENU(),
                                                              onClick: handleMenuClick
                                                            }}
                                                                      trigger={['click']} align={{offset: [26, -26]}}>
                                                              <div className={'flex-center'} style={{
                                                                height: '100%',
                                                                width: '36px',
                                                                flexShrink: '0',
                                                                marginRight: '-10px',
                                                              }} onClick={(event) => {
                                                                mCurrentFavorNote = item;
                                                                var arrayFavs = [...arrayFavirates];
                                                                arrayFavs.forEach(p => p.isOpen = false);

                                                                item.isOpen = true;
                                                                setArrayFavirates(arrayFavs);

                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                              }}>
                                                                <img className='img-medium-small'
                                                                     style={{flexShrink: '0'}}
                                                                     src={getImagePathWithTheme("horizontal_more")}/>
                                                              </div>

                                                            </Dropdown>
                                                        }
                                                      </li>
                                                    </Dropdown>
                                                  </div>
                                              )
                                            }
                                          </Draggable>
                                      )
                                    }
                                  </ul>
                              )
                            }
                          </Droppable>
                        </DragDropContext>

                      </div>
                    //endregion
                  }

                  {
                    <div id={'div-tree-favor-list-shit-tree'} style={{
                      display: isExpandFavor ? 'inherit' : 'none',
                      // height:isExpandFavor?((arrayFavirates.length >= 7?7:(arrayFavirates.length+1))*36 - 36)+'px':'auto'
                      height: refreshFavorHeight(),
                      overflowY: isFavorHover ? ('auto') : 'hidden',
                      overflowX: 'hidden',
                    }} onMouseEnter={() => {
                      setIsFavorHover(true);
                      // mIsMouseInFavor.current = true;
                    }}
                         onMouseLeave={() => {
                           setIsFavorHover(false);
                         }}>
                      <ConfigProvider
                          theme={{
                            components: {
                              Tree: {
                                colorPrimary: 'var(--primary-color)',
                                indentSize: 0,
                                titleHeight: 32,
                                motionDurationFast: '0s',
                                motionDurationMid: '0s',
                                motionDurationSlow: '0s'
                              }
                            }
                          }}>
                        <DirectoryTree
                            className={'favor-tree-class'}
                            switcherIcon={null}
                            expandedKeys={expandKeys}
                            onExpand={onExpand}
                            onSelect={onSelect}
                            treeData={arrayFavirates}
                            selectedKeys={treeSelectedKeys}
                            showIcon={false}
                            blockNode={true}
                            draggable={treeDraggable}
                            onDragOver={onDragOver}
                            onDragStart={onDragStart}
                            onDragEnd={onDragEnd}
                            onDrop={onDrop}

                            titleRender={(nodeData: any) => {
                              if (nodeData.isEditable) {
                                return (
                                    <div className={'custom-tree-node'}
                                         style={{display: "flex", width: "100%", alignItems: "center", height: '32px'}}>
                                      <img className='menu-icon-size'
                                           style={{opacity:isDarkMode()?'1':'1'}}
                                           src={(nodeData.isFolder && expandKeys.some(p => p.includes(nodeData.key))) ? getImagePathWithTheme('tree_folder_expand.svg') : getImagePathWithTheme(getFavorImage(nodeData))}/>
                                      <Input className='default-font-size font-family-regular ml-6'
                                             value={nodeData.name}
                                             style={{
                                               color: "var(--text-color)",
                                               marginLeft: '8px',
                                               paddingLeft: '0px',
                                               flexGrow: 1,
                                               marginTop: '1px',
                                               marginBottom: '0px'
                                             }}
                                             variant={"borderless"}
                                             autoFocus={true}
                                             onKeyPress={(e) => {
                                               if (e.charCode == 13) {
                                                 e.currentTarget.blur();
                                               }
                                             }}
                                             onChange={(e) => {
                                               const data = [...arrayFavirates];
                                               loop(data, nodeData.key, (item) => {
                                                 item.editValue = e.target.value;
                                                 item.name = item.editValue;
                                               });
                                               setArrayFavirates(data);
                                             }}
                                             onFocus={(e) => {
                                               //保存之前的数据，如果为空的话进行还原...
                                               const data = [...arrayFavirates];
                                               loop(data, nodeData.key, (item) => {
                                                 item.tempName = item.name;
                                               });
                                               setArrayFavirates(data);
                                               setTreeDraggable(false);
                                             }}
                                             onBlur={(e) => {
                                               const data = [...arrayFavirates];
                                               loop(data, nodeData.key, (item) => {
                                                 let szName = e.target.value;
                                                 if (!szName) {
                                                   szName = item.tempName;
                                                 }
                                                 item.editValue = szName;
                                                 item.name = szName;
                                                 item.isEditable = false;
                                                 item.isHover = item.isOpen = false;
                                                 mFavorEditableId.current = null;
                                                 //更新到库.
                                                 updateFavorFolder(item).then(res => {
                                                   onNeedRefreshFavorAAAAAAA();
                                                 });
                                               });
                                               setArrayFavirates(data)
                                               setTreeDraggable(true);
                                             }}
                                      />
                                      {/*<div style={{width:'16px',height:'16px',marginLeft:'16px'}}></div>*/}
                                    </div>
                                )
                              } else {
                                return (
                                    <Dropdown overlayClassName='default-dropdown-style' menu={{
                                      items: nodeData.isFolder ? itemsFolder : ARRAY_FAVOR_MENU(nodeData),
                                      onClick: function (info: any) {
                                        info.domEvent.stopPropagation();
                                        if (info.key == 'rename') {
                                          nodeData.isEditable = true;
                                          const arrayTmp = [...arrayFavirates];
                                          setArrayFavirates(arrayTmp);
                                        } else if (info.key == 'delete') {
                                          info.domEvent.stopPropagation();
                                          window.showMessageBox(t("Delete folder"), t("SureDeleteFolder"), t("Cancel"), t("Delete"), null, () => {
                                            deleteFavorFolder(nodeData).then(res => {
                                              const arrayTmp = [...arrayFavirates];
                                              const nIndex = arrayTmp.findIndex(p => p.id == nodeData.id);
                                              arrayTmp.splice(nIndex, 1);
                                              setArrayFavirates(arrayTmp);
                                            });
                                          })
                                        } else if (info.key == 'cancelFavor') {
                                          mCurrentFavorNote = nodeData;
                                          handleMenuClick({key: 'cancelFavor'})
                                        }else if (info.key == 'editLink') {
                                          window.showDialogAddLink(nodeData);
                                        }
                                      }
                                    }}
                                              trigger={['contextMenu']} overlayStyle={{width: 'auto'}}
                                              onOpenChange={(open) => {
                                                // isMoreOpend = open;
                                              }}>
                                      <div className='custom-tree-node' id={nodeData.id} onMouseDown={(e) => {
                                        // if ((Date.now() - nLastClickTime.current) < 260) {
                                        //   if (nodeData.isFolder) {
                                        //     nodeData.isEditable = true;
                                        //     mFavorEditableId.current = nodeData.id;
                                        //     setTimeout(()=>{
                                        //       const arrayTmp = [...arrayFavirates];
                                        //       setArrayFavirates(arrayTmp);
                                        //     },100)
                                        //   }
                                        // }
                                        // nLastClickTime.current = Date.now();
                                      }}
                                           style={{
                                             display: "flex",
                                             width: "calc(100% - 0px)",
                                             alignItems: "center",
                                             overflow: 'hidden',
                                             height: '32px',
                                             maxWidth: '190px',
                                           }} onMouseEnter={() => {
                                        const arrayTmp = [...arrayFavirates];
                                        arrayTmp.forEach(p => {
                                          if (p.children) {
                                            p.children.forEach(pp => {
                                              pp.isHover = false;
                                              pp.isOpen = false;
                                            })
                                          }
                                          p.isHover = false;
                                        })
                                        if (mFavorEditableId.current) {
                                          const nnnn = arrayTmp.find(p => p.id == mFavorEditableId.current);
                                          if (nnnn) {
                                            nnnn.isEditable = true;
                                          }
                                        }
                                        nodeData.isHover = true;
                                        setArrayFavirates(arrayTmp);
                                      }} onMouseLeave={() => {
                                        const arrayTmp = [...arrayFavirates];
                                        arrayTmp.forEach(p => {
                                          if (p.children) {
                                            p.children.forEach(pp => {
                                              pp.isHover = false;
                                              pp.isOpen = false;
                                            })
                                          }
                                          p.isHover = false;
                                        })
                                        if (mFavorEditableId.current) {
                                          const nnnn = arrayTmp.find(p => p.id == mFavorEditableId.current);
                                          if (nnnn) {
                                            nnnn.isEditable = true;
                                          }
                                        }
                                        setArrayFavirates(arrayTmp);
                                      }}>
                                        <img className='menu-icon-size'
                                             style={{opacity:isDarkMode()?'1':'1'}}
                                             src={nodeData.isFolder && expandKeys.some(p => p.includes(nodeData.key)) ? getImagePathWithTheme('tree_folder_expand.svg') : getImagePathWithTheme(getFavorImage(nodeData))}/>
                                        <span className='default-font-size font-family-regular ml-6 span-single-line'
                                              style={{
                                                color: 'var(--home-left-normal-item-color)',
                                                marginLeft: '8px', paddingLeft: '0px', cursor: "pointer",
                                                marginTop: '1px',
                                                flexGrow: 1, marginBottom: '0px',
                                                display: 'block',
                                                marginRight: '6px'
                                              }}>{nodeData.type == 'card' ? getCardTitle0(nodeData) : (nodeData.name || t("Untitled"))}</span>
                                        {
                                            nodeData.isFolder &&
                                            <Dropdown overlayClassName='default-dropdown-style'
                                                      align={{offset: [26, -16]}} menu={{
                                              items: itemsFolder, onClick: function (info: any) {
                                                if (info.key == 'rename') {
                                                  nodeData.isEditable = true;
                                                  // const arrayTmp = [...arrayFavirates];
                                                  // setArrayFavirates(arrayTmp);
                                                } else if (info.key == 'delete') {
                                                  info.domEvent.stopPropagation();
                                                  window.showMessageBox(t("Delete folder"), t("SureDeleteFolder"), t("Cancel"), t("Delete"), null, () => {
                                                    deleteFavorFolder(nodeData).then(res => {
                                                      const arrayTmp = [...arrayFavirates];
                                                      const nIndex = arrayTmp.findIndex(p => p.id == nodeData.id);
                                                      arrayTmp.splice(nIndex, 1);
                                                      setArrayFavirates(arrayTmp);
                                                    });
                                                  })
                                                }
                                              }
                                            }}
                                                      trigger={['click']} overlayStyle={{width: 'auto'}}
                                                      onOpenChange={(open) => {
                                                        // isMoreOpend = open;
                                                      }}>
                                              <div className={'flex-center'} style={{
                                                height: '100%',
                                                width: '26px',
                                                flexShrink: '0',
                                                marginRight: '0px',
                                              }} onClick={(event) => {
                                                event.stopPropagation();
                                              }}>
                                                <img className='img-medium-small'
                                                     style={{
                                                       flexShrink: '0',
                                                       opacity: nodeData.isHover ? '1' : '0',
                                                     }}
                                                     src={getImagePathWithTheme("horizontal_more")}/>
                                              </div>

                                            </Dropdown>
                                        }

                                        {
                                            !nodeData.isFolder &&
                                            <Dropdown menu={{
                                              items: ARRAY_FAVOR_MENU(nodeData),
                                              onClick: handleMenuClick
                                            }}
                                                      trigger={['click']} align={{offset: [26, -26]}}>
                                              <div className={'flex-center'} style={{
                                                height: '100%',
                                                width: '26px',
                                                flexShrink: '0',
                                                marginRight: '0px',
                                                // background:'darkred'
                                              }} onClick={(event) => {
                                                mCurrentFavorNote = nodeData;
                                                var arrayFavs = [...arrayFavirates];
                                                arrayFavs.forEach(p => {
                                                  if (p.children) {
                                                    p.children.forEach(pp => {
                                                      pp.isHover = false;
                                                      pp.isOpen = false;
                                                    })
                                                  }
                                                  p.isHover = false;
                                                  p.isOpen = false;
                                                });
                                                nodeData.isOpen = true;
                                                setArrayFavirates(arrayFavs);

                                                event.preventDefault();
                                                event.stopPropagation();
                                              }}>
                                                <img className='img-medium-small'
                                                     style={{flexShrink: '0', opacity: nodeData.isHover ? '1' : '0'}}
                                                     src={getImagePathWithTheme("horizontal_more")}/>
                                              </div>

                                            </Dropdown>
                                        }

                                      </div>
                                    </Dropdown>
                                )
                              }
                            }}
                        />
                      </ConfigProvider>
                    </div>
                  }

                </div>
              //endregion
            }


            {/*//最近*/}
            {
                homeLeftMenu?.recent &&
                arrayRecents.length > 0 &&
                <div style={{
                  marginTop: '10px',
                  height: leftItemHeight.recentHeight,
                  overflow: 'hidden',
                  // minHeight: '80px',
                }}>
                  <div
                      className='folderItemFolderHeader flex-row-vertical-center hovered border-radius-8 overflow-hidden cursor-pointer'
                      onClick={() => {
                        setIsExpandRecent(!isExpandRecent);
                      }} onMouseEnter={(e) => {
                    setIsMoveLeftPartRecent(true);
                  }} onMouseLeave={(e) => {
                    setIsMoveLeftPartRecent(false);
                  }} style={{background: 'transparent', cursor: 'pointer'}}>
                    {/*<img className='img-medium-small' src={getImagePathWithTheme("favor")}/>*/}
                    <div className={'flex-row-vertical-center'}>
                      <img className='img-16' style={{
                        marginLeft: '0px',
                        transform: isExpandRecent ? 'rotate(0deg)' : 'rotate(-90deg)',
                        visibility: isMoveLeftPartRecent ? 'visible' : 'visible'
                      }} src={getImagePathWithTheme("home_small_favor_dropdown.svg")}/>

                      <span className='ml-6 theme-text-color'
                            style={{flexGrow: '1', color: 'var(--home-favor-text-color)'}}>{t("Recents").toUpperCase()}</span>
                    </div>

                    {
                      // isMoveLeftPartFavor && false &&
                      // <img className='img-mini-small-12' src={getImagePathWithTheme('home_dropdown')}
                      //      style={{
                      //        transform: isExpandFavor ? 'rotate(180deg)' : 'rotate(0deg)',
                      //        marginRight: '0px',
                      //        width: '12px',
                      //        height: '7px'
                      //      }}
                      //      onClick={() => {
                      //
                      //      }} rotate={isExpandFavor ? 0 : 180}/>
                    }

                  </div>
                  <div style={{
                    overflow: isRecentHover ? 'auto' : 'hidden',
                    height: '100%',
                    display: isExpandRecent ? 'inherit' : 'none',
                  }}
                       onMouseEnter={(event) => {
                         setIsRecentHover(true)
                       }} onMouseLeave={() => {
                    setIsRecentHover(false)
                  }}>
                    <ul className='ul-item'>
                      {
                        arrayRecents.map((item, i) =>
                            <Dropdown key={item.id} overlayClassName='default-dropdown-style'
                                      menu={{items: arrayRecentMenu(item)}} trigger={['contextMenu']}>
                              <li data-id={item.id} style={{
                                paddingLeft: '16px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                paddingRight: '12px',
                                color: (item.isHover || item.isSelected) ? 'var(--select-item-color)' : 'var(--home-left-normal-item-color)',
                                background: getHoverOrSelectColor(item)
                              }} key={i}
                                  onMouseEnter={() => {
                                    var arrayNew: any = [...arrayRecents];
                                    arrayNew.forEach(p => p.isHover = false);
                                    item.isHover = true;
                                    item.isOpen = false;
                                    setArrayRecents(arrayNew);
                                  }}
                                  onMouseLeave={() => {
                                    var arrayNew: any = [...arrayRecents];
                                    arrayNew.forEach(p => {
                                      p.isHover = false;
                                      p.isOpen = false;
                                    });
                                    setArrayRecents(arrayNew);
                                  }}
                                  onContextMenu={(e) => {
                                    mCurrentFavorNote = item;
                                    // const szId = e.currentTarget.dataset.id;
                                    // getNoteById(szId as string).then(res => {
                                    //   mCurrentFavorNote = res;
                                    // })
                                  }} onClick={async (event) => {
                                event.preventDefault();
                                event.stopPropagation();

                                //增加判断，如果画布那边正在加载，不要响应.等加载完了，再响应...
                                if (window.isLoadingProject){
                                  if (window.isLoadingProject()) {
                                    console.log('****************************************************isLoadingProject*************');
                                    return
                                  }
                                }

                                // setArrayRecentContextMenu(arrayRecentMenu(item))

                                if (event.target.localName == 'img'
                                    || event.target.className == "ant-dropdown-menu-title-content"
                                    || event.target.className == "anticon"
                                    || event.target.className == 'ant-dropdown-menu-item ant-dropdown-menu-item-active') return;

                                const isNavItem = await navFavor(item);
                                if (isNavItem) {
                                  global.g_currentRecentId = item.id;
                                  //选中当前项目
                                  var arrayNew = [...arrayRecents];
                                  arrayNew.forEach(p => p.isSelected = false);
                                  item.isSelected = true;
                                  setArrayRecents(arrayNew);

                                  //将favor全部置为未选中
                                  resetFavorNoSelect();
                                  setSelectMenuItem('')
                                }
                              }}>

                                <img className='menu-icon-size' style={{marginLeft:'1px'}}
                                     src={getImagePathWithTheme(item.type ? "favor_card.svg" : "favor_project.svg")}/>
                                <span className='ml-6 span-single-line'
                                      style={{
                                        marginLeft: '8px',
                                        flexGrow: '1',
                                        marginTop: '1px'
                                      }}>{getCardTitle(item)}</span>
                                {
                                    item.isHover &&
                                    <Dropdown open={item.isOpen} menu={{items: arrayRecentMenu(item)}}
                                              trigger={['click']} align={{offset: [26, -26]}}>
                                      <div className={'flex-center'} style={{
                                        height: '100%',
                                        width: '36px',
                                        marginRight: '-10px',
                                        flexShrink: '0'
                                      }} onClick={(event) => {
                                        mCurrentFavorNote = item;

                                        // setArrayRecentContextMenu(arrayRecentMenu(item))

                                        var arrayNewRecents = [...arrayRecents];
                                        arrayNewRecents.forEach(p => p.isOpen = false);

                                        item.isOpen = true;
                                        item.isHover = true;
                                        setArrayRecents(arrayNewRecents);

                                        event.preventDefault();
                                        event.stopPropagation();
                                      }}>
                                        <img className='img-medium-small'
                                             style={{flexShrink: '0', background: 'transparent'}}
                                             src={getImagePathWithTheme("horizontal_more")}/>
                                      </div>

                                    </Dropdown>
                                }

                              </li>
                            </Dropdown>
                        )
                      }
                    </ul>
                  </div>
                </div>
            }

            {/*<div style={{flexGrow: '1'}}></div>*/}
            {/*<div className='line' style={{background: 'var(--home-top-border-color)', margin: '0 8px'}}></div>*/}
            {/*//设置---dispose*/}
            <div className={style.setting} style={{flexShrink: '0', display: 'none'}}>
              <ul style={{padding: '0px'}}>
                <li onClick={() => {
                  navigate('/home/trash');
                  setSelectMenuItem('trash');
                }}>
                  <div style={{
                    backgroundColor: selectMenuItem == 'trash' ? 'var(--hover-background-color)' : 'transparent',
                    height: '100%',
                    width: 'calc(100% + 16px)',
                    marginLeft: '-16px',
                    paddingLeft: '16px'
                  }} className='flex-row-vertical-center'>
                    <img className='img-mini-small' src={getImagePathWithTheme('left_trash')}/>
                    <span className={'medium-font-bold'}
                          style={{marginLeft: '9px', marginTop: '0px'}}>{t("Trash")}</span>
                  </div>
                </li>
                <li onClick={() => {
                  setIsShowSettingDialog(true);
                  setTimeout(() => {
                    dialogSetRef?.current?.onDialogShow();
                  }, 200);
                  // postMessage(EVENT_REFRESH_USER_IFNO,{});
                }}>
                  <img className='img-mini-small' src={getImagePathWithTheme("set")}/>
                  <span className={'medium-font-bold'}
                        style={{marginLeft: '9px', marginTop: '0px'}}>{t("Settings")}</span>
                </li>
              </ul>
            </div>

            <div style={{flexGrow: '1'}}></div>

            {
                (DEBUG || (showUpgrade && !hasAppUpdate)) &&
                <DialogFreeUserUpgrade ref={dialogFreeUserUpgradeRef}/>
            }


            {/*//底部栏...*/}
            <div className={'flex-row-vertical-center'}
                 style={{
                   borderTop: '1px solid var(--line-color)',
                   height: '50px',
                   position: 'absolute',
                   bottom: '0px',
                   left: '1px',
                   width: '100%',
                   padding: '0 10px',
                   background: 'var(--home-left-background-color)'
                 }}>

              <Tooltip arrow={false} title={t("Settings")}>
                <img className={'cursor-pointer hovered-gray-radius'} style={{width: '32px', height: '32px'}}
                     src={getImagePathWithTheme("home_setting_1.svg")} onClick={() => {
                  dialogSetRef?.current?.onDialogShow();
                }}/>
              </Tooltip>

              {/*<Dropdown placement={'top'} overlayClassName={'default-dropdown-style'} overlayStyle={{minWidth: '240px'}}*/}
              {/*          align={{offset: [20, -22]}} trigger={['click']} menu={{items: itemCreateNew}}>*/}
              {/*  <Tooltip title={t("New")} arrow={false}>*/}
              {/*    <div style={{marginLeft:'-8px'}} className={'img-32 hovered flex-center'}>*/}
              {/*      <img className='img-14 cursor-pointer ' src={getImagePathWithTheme("home_bottom_add")}/>*/}
              {/*    </div>*/}
              {/*  </Tooltip>*/}
              {/*</Dropdown>*/}

              <Dropdown placement={'top'} overlayClassName={'default-dropdown-style-1'}
                        align={{offset: [86, -22]}} trigger={['click']} menu={{items: arraySyncMenu}}>
                <Tooltip title={t("Sync")} arrow={false}>
                  <div style={{marginLeft: '6px'}} className={'img-32 hovered flex-center'}>
                    <img className='img-32 cursor-pointer' src={getImagePathWithTheme("home_bottom_sync.svg")}
                        // onClick={() => {
                        //   fileInputRef.current?.click();
                        // }}
                    />
                  </div>
                </Tooltip>
              </Dropdown>

              {/*<Dropdown placement={'top'} overlayClassName={'default-dropdown-style'} overlayStyle={{minWidth: '180px'}}*/}
              {/*          align={{offset: [20, -22]}} trigger={['click']} menu={{items: itemImportNew}}>*/}
              {/*  <Tooltip title={t("Import")} arrow={false}>*/}
              {/*    <div style={{marginLeft: '6px'}} className={'img-32 hovered flex-center'}>*/}
              {/*      <img className='img-32 cursor-pointer' src={getImagePathWithTheme("home_bottom_import")}*/}
              {/*          // onClick={() => {*/}
              {/*          //   fileInputRef.current?.click();*/}
              {/*          // }}*/}
              {/*      />*/}
              {/*    </div>*/}
              {/*  </Tooltip>*/}
              {/*</Dropdown>*/}

              <Tooltip arrow={false} title={t("Trash")}>
                <img className={'cursor-pointer hovered-gray-radius ml-6'}
                     style={{width: '32px', height: '32px', marginTop: '1px'}}
                     src={getImagePathWithTheme("home_trash_1.svg")} onClick={() => {
                  navigate('/home/trash');
                }}/>
              </Tooltip>

              <div style={{flexGrow: '1'}}></div>
              {/*<Tooltip title={t("Helper")} arrow={false}>*/}
              <Dropdown menu={{items: MENU_HELPER_MORE}} trigger={["click"]} align={{
                offset: [0, 8]
              }}>
                <div style={{}} className={'img-32 hovered flex-center'}>
                  <Tooltip arrow={false} title={t("HelpAndResource")}>
                    <img className='img-32 cursor-pointer' src={getImagePathWithTheme("home_bottom_helper.svg")}
                         onClick={() => {
                           // if (isZh()) {
                           //   ipcSend("open-url", import.meta.env.VITE_HTTP_HELPER_URL_ZH)
                           // } else {
                           //   ipcSend("open-url", import.meta.env.VITE_HTTP_HELPER_URL)
                           // }
                         }}/>
                  </Tooltip>
                </div>
              </Dropdown>
              {/*</Tooltip>*/}
            </div>

          </div>

          {/*//右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分右侧部分*/}
          <div className={style.right} style={{
            height: getRightPartHeight(),
            background: isWhiteDefaultBackground() ? 'var(--background-color)' : 'transparent'
          }}>
            <Outlet/>
          </div>

          <SettingIndex ref={dialogSetRef}/>

          <DialogNewFolder ref={dialogNewFolderRef} onOkEvent={() => {

          }}/>

          <DialogTemplate ref={dialogTemplateRef} onTemplateItemClick={onTemplateItemClick}/>

          {/********首次进入的启动页*********/}
          {/*<div style={{position:'absolute',left:'0',top:'0',height:'100%',width:'100%',zIndex:'100',backgroundColor:'#EBF5FF',display:isAppFirst?'inherit':'none'}}>*/}
          {/*  <span style={{position:'absolute',left:'20px',top:'20px',color:'#052E3F',fontSize:'20px',fontWeight:'500'}}>{t("AppName")}</span>*/}
          {/*  <div className='flex-column-center' style={{width:'100%',height:'100%'}}>*/}
          {/*    <p style={{color:'#052E3F',fontSize:'44px',fontWeight:'500',fontFamily: 'AbrilFatface'}}>{t("Thank create")}</p>*/}
          {/*    <p style={{color:'#2B80DB',fontSize:'44px',fontWeight:'500',marginTop:'14px',fontFamily: 'AbrilFatface'}}>{t("On the canvas")}</p>*/}
          {/*    <p style={{color:'#052E3F',fontSize:'18px',whiteSpace:'pre-line',textAlign:'center',marginTop:'34px',lineHeight:'29px',fontFamily:'Poppins'}}>{t("Offline visual suite")}</p>*/}
          {/*    <div style={{minWidth:'208px',marginTop:'26px',height:'50px',fontStyle:'20px',borderRadius:'8px',fontSize:'20px'}} className='button-solid-style flex-center hovered' onClick={()=>{*/}
          {/*      localStorage.setItem(SYS_CONFIG_KEY_APPFIRST,'false');*/}
          {/*      setIsAppFirst(false);*/}
          {/*    }}>{t("Start")}</div>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {
              (isAppFirst) &&
              <FirstInitPage onStartClick={() => {
                localStorage.setItem(SYS_CONFIG_KEY_APPFIRST, 'false');
                setIsAppFirst(false);
                onShowStoreTips();
                onShowChangeTabTip();
              }}/>
          }

          <DialogMessageBox ref={dialogMessageBoxRef}/>

          <DialogMovetoFolder ref={dialogMovetoFolderRef}/>

          {
              (isShowUpgradeDialog) &&
              <DialogUpdateAvaliable ref={dialogUpdateAvaliable} hasFreeUserUpgradeTip={showUpgrade && !hasAppUpdate}
                                     onCloseEvent={() => {
                                       setIsShowUpgradeDialog(false)
                                     }}/>
          }

          {
              isShowDialogHelper &&
              <DialogHelper ref={dialogHelperRef}/>
          }


          {
              APP_WEB_SITE &&
              //使用空间
              <div style={{
                position: "absolute",
                left: '12px',
                bottom: '122px',
                width: '220px',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '12px',
                display: 'flex',
                flexDirection: 'column',
              }}>
                <span>当前计划: Free</span>
                <span className={'mt-6'}>当前用量: {s3Size}</span>
              </div>
          }

        </div>

        {/*隐藏的文件选择*/}
        <div className="file-selector">
          <input
              ref={fileInputRef}
              type="file"
              id="file-input"
              multiple={fileMultiply}
              accept={fileImportAccept}
              style={{display: 'none'}}
              onChange={async (event) => {
                const file = event.target.files[0];
                //判断类型，做相应的处理
                const szFileName = file.name.toLowerCase();
                if (szFileName.endsWith('.pcanvas') || szFileName.endsWith('.pcanvasx')) {
                  isZipFile(file).then(res => {
                    if (res) {
                      let zip = new JSZip();
                      zip.loadAsync(file).then(async (zipData: any) => {
                        //
                        for (const [name, zipFile] of Object.entries(zipData.files)) {
                          if (name == ZIP_DATA_DB_NAME) {
                            const szData = await zipFile.async('string');
                            onImportNoteData(szData, file.path);
                          } else {
                            //保存到files文件夹
                            const blob = await zipFile.async('blob');
                            let arrayBuffer = await blobToArrayBuffer(blob);
                            ipcInvoke('write-one-buffer-files', {fileName: name, data: arrayBuffer})
                          }
                        }
                        console.log(zipData);
                      })
                    } else {
                      let reader = new FileReader();
                      reader.onload = function (e) {
                        onImportNoteData(e.target.result as string, file.path);
                      }
                      reader.readAsText(file, "utf-8");
                    }
                  })
                } else if (szFileName.endsWith('.md')) {
                  importMarkdown(file).then(res => {
                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                  });
                } else {
                  //其他文件...导入library
                  // window.showProgress(t("Importing..."))
                  const szExistFileName = await ipcInvoke('cmp-file-md5', {filePath: file.path});

                  if (szExistFileName) {
                    window.showMessageBox(t("DuplicateFileFound"), t("TheSameFileAlreadyExists"), t("CreateNewCopy"), t("Ok"), async () => {
                      //create new copy-----------
                      await copyOneFile(file);
                    }, () => {
                      // window.closeProgress();
                    })
                  } else {
                    //单个文件copy----------------
                    await copyOneFile(file);
                  }
                }

                fileInputRef.current.value = '';
              }}
          />
        </div>
      </div>
  )
}
export default withGuard(Home)






















